/* EXCENTRED® — Runde 19: Shop-Funktionen
   1  Ausverkaufte Größe antippen → Benachrichtigungs-Formular öffnet direkt
   2  ?ex_notify=1 (aus den Karten) → Formular öffnet auf der Produktseite
   3  Karten „You may also like“: Größe wählen + direkt in den Warenkorb
   4  Warenkorb: „Merken“ verschiebt einen Artikel in die Merkliste
   5  Kollektionsende: „x von y Produkten“ + Mehr laden (statt Endlos-Scroll)
   6  Schalter „Verfügbar“ in der Filterzeile
   7  Kollektionstext (SEO) mit „Mehr lesen“
   8  Benachrichtigungs-Fenster: Produkt + gewählte Größe als Kontext (Runde 21)
   9–11 Runde 28: Warenkorb, Style-Vorschaubilder, Nach-oben-Knopf
   12 Runde 29: Größenwahl – Swatch King und Varianten-Auswahl synchron (ein Tipp reicht)
      Runde 44: Swatch King ersetzt – native Auswahl (snippets/variant-main-picker.liquid), hier nur
      noch Benachrichtigen beim ersten Tipp und Auswahl-Übernahme beim Farbwechsel
   13 Runde 30: doppeltes Swym-Merkliste-Icon vom Seitenende entfernen
   14 Runde 33: Logo + Streichpreis in Produktfarbe (Farb-Varianten, Antippen eines Farbfelds)
   15 Runde 33: Such-Fenster – „Zuletzt gesucht“, Bilder beim Öffnen sofort laden
   16 Runde 34: Farbfelder – Name über den Feldern folgt dem Hover, Unterstrich wechselt beim Antippen sofort
   17 Runde 41: Farbwechsel ohne Neuladen – nur der Seiteninhalt wird getauscht, Adresse wechselt mit
      Runde 42: Nachbarfarben im Leerlauf vorladen (inkl. erstem Bild), kein Aufblenden bei sofortigem
      Wechsel, Ereignis ex_colour_switch mit Produktdaten (für ein optionales Tracking-Pixel)
   18 Runde 45: Produkt-Reiter – Zahl und Einheit bleiben zusammen (100 %, 220 g/m², 30 °C)
   9b Runde 63: Warenkorb – Streichpreis bei Gratis-Artikeln, Großansicht der Geschenke
   Optik: assets/excentred-master.css (Abschnitte 48–55). Keine Abhängigkeit zu
   ex-cards.js außer der gemeinsamen Swym-Warteschlange (window.SwymCallbacks). */
(function () {
  'use strict';

  var LANG = (document.documentElement.lang || 'de').slice(0, 2);

  function t(map) {
    return map[LANG] || map.en;
  }

  // ------------------------------------------------------------------
  // 1 + 2 · Benachrichtigen (Privy über x-back-in-stock-v2.js)
  // Der Button .x-bis-btn erscheint, sobald die gewählte Variante ausverkauft ist
  // und Privy geladen hat. Wir warten darauf und öffnen dann das Formular.
  // ------------------------------------------------------------------
  function notifyButton() {
    var b = document.querySelector('.product-details .x-bis-btn') || document.querySelector('.x-bis-btn');
    if (b && b.style.display === 'flex') return b;
    return null;
  }

  function openNotify(maxMs) {
    var waited = 0;
    var step = 120;
    (function tick() {
      var b = notifyButton();
      if (b) {
        b.click();
        return;
      }
      waited += step;
      if (waited < maxMs) setTimeout(tick, step);
    })();
  }

  // Runde 44: native Auswahl – ausverkaufte Größe antippen wählt sie und öffnet das Formular,
  // sobald variant-picker.js die neue Variante gemeldet hat (variant:update). War die Größe schon
  // gewählt, gibt es kein Ereignis → sofort öffnen. Tastatur (Pfeiltasten) öffnet bewusst nichts.
  var notifyWant = 0;

  document.addEventListener(
    'click',
    function (event) {
      if (!event.isTrusted || !event.target.closest) return;
      var item = event.target.closest('.product-details variant-picker .ex-vo__item.is-soldout');
      if (!item) return;
      var input = item.querySelector('input');
      if (!input) return;
      // data-current-checked setzt variant-picker.js erst im change-Handler → hier noch der alte Stand
      if (input.getAttribute('data-current-checked') === 'true') {
        notifyWant = 0;
        setTimeout(function () {
          openNotify(3500);
        }, 60);
        return;
      }
      var mine = (notifyWant = Date.now());
      setTimeout(function () {
        if (notifyWant !== mine) return;
        notifyWant = 0;
        openNotify(3500);
      }, 2500);
    },
    true
  );

  document.addEventListener('variant:update', function () {
    if (!notifyWant || Date.now() - notifyWant > 5000) return;
    notifyWant = 0;
    setTimeout(function () {
      openNotify(3500);
    }, 80);
  });

  function autoNotifyFromUrl() {
    try {
      var params = new URLSearchParams(location.search);
      if (params.get('ex_notify') !== '1') return;
      openNotify(15000);
      params.delete('ex_notify');
      var qs = params.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) {}
  }

  // ------------------------------------------------------------------
  // 3 · Karten: Größe wählen + Warenkorb
  // ------------------------------------------------------------------
  function cartUpdated(cart) {
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'ex-cardbuy', data: { itemCount: cart.item_count, source: 'ex-cardbuy' } };
      document.dispatchEvent(ev);
    } catch (e) {}
    try {
      if (typeof window.refreshOxifyCartDrawer === 'function') window.refreshOxifyCartDrawer({ showLoading: false });
    } catch (e) {}
    setTimeout(function () {
      try {
        if (typeof window.openIACartDrawer === 'function') window.openIACartDrawer();
      } catch (e) {}
    }, 350);
  }

  function addToCart(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.json();
      });
  }

  function cardOf(el) {
    return el.closest('li') || el.closest('.product-card') || el.closest('[data-ex-cardbuy]');
  }

  function closeLists(except) {
    var open = document.querySelectorAll('.ex-cardbuy__list:not([hidden])');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].hidden = true;
      var tg = open[i].parentElement.querySelector('[data-ex-cardbuy-toggle]');
      if (tg) tg.setAttribute('aria-expanded', 'false');
      var card = cardOf(open[i]);
      if (card) card.classList.remove('ex-cardbuy-open');
    }
  }

  function setBtn(root, mode) {
    var btn = root.querySelector('[data-ex-cardbuy-btn]');
    var label = root.querySelector('[data-ex-cardbuy-label]');
    if (!btn || !label) return;
    btn.classList.toggle('is-notify', mode === 'notify');
    btn.disabled = mode === 'off';
    label.textContent = mode === 'notify' ? root.getAttribute('data-t-notify') : root.getAttribute('data-t-add');
  }

  function initCardBuy(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var single = root.querySelector('[data-ex-cardbuy-single]');
    if (single) {
      root.dataset.id = single.value;
      root.dataset.available = single.getAttribute('data-available');
      setBtn(root, single.getAttribute('data-available') === 'true' ? 'add' : 'notify');
    }
  }

  // Capture-Phase: Die Karte hat einen Link über der ganzen Fläche und einen eigenen
  // Klick-Handler (View Transition) – Klicks in der Auswahl dürfen dort nicht ankommen.
  document.addEventListener('click', function (event) {
    var root = event.target.closest('[data-ex-cardbuy]');
    if (!root) {
      closeLists(null);
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var toggle = event.target.closest('[data-ex-cardbuy-toggle]');
    var option = event.target.closest('[data-ex-cardbuy-option]');
    var btn = event.target.closest('[data-ex-cardbuy-btn]');
    if (!toggle && !option && !btn) return;
    initCardBuy(root);

    if (toggle) {
      var list = root.querySelector('.ex-cardbuy__list');
      var willOpen = list.hidden;
      closeLists(list);
      list.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var card = cardOf(root);
      if (card) card.classList.toggle('ex-cardbuy-open', willOpen);
      return;
    }

    if (option) {
      var id = option.getAttribute('data-id');
      var available = option.getAttribute('data-available') === 'true';
      root.dataset.id = id;
      root.dataset.available = available ? 'true' : 'false';
      var current = root.querySelector('[data-ex-cardbuy-current]');
      if (current) current.textContent = option.getAttribute('data-label');
      var sel = root.querySelectorAll('[data-ex-cardbuy-option]');
      for (var i = 0; i < sel.length; i++) sel[i].setAttribute('aria-selected', sel[i] === option ? 'true' : 'false');
      root.classList.add('has-choice');
      closeLists(null);
      setBtn(root, available ? 'add' : 'notify');
      return;
    }

    if (btn && !btn.disabled) {
      var vid = root.dataset.id;
      if (!vid) return;
      if (root.dataset.available !== 'true') {
        location.href = root.getAttribute('data-url') + '?variant=' + vid + '&ex_notify=1';
        return;
      }
      btn.classList.add('is-busy');
      addToCart(vid)
        .then(function (cart) {
          btn.classList.remove('is-busy');
          var label = root.querySelector('[data-ex-cardbuy-label]');
          if (label) label.textContent = root.getAttribute('data-t-added');
          btn.classList.add('is-done');
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (label) label.textContent = root.getAttribute('data-t-add');
          }, 1800);
          cartUpdated(cart);
        })
        .catch(function () {
          btn.classList.remove('is-busy');
        });
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLists(null);
  });

  // ------------------------------------------------------------------
  // 4 · Warenkorb (iCart / Oxify): „Merken“ = in die Merkliste + aus dem Warenkorb
  // ------------------------------------------------------------------
  var swymApi = null;
  function whenSwym(fn) {
    if (!swymApi && window._swat && typeof window._swat.addToWishList === 'function') swymApi = window._swat;
    if (swymApi) return fn(swymApi);
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      swymApi = swat;
      fn(swat);
    });
  }

  var BOOKMARK =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M6.1 2.9h7.8c.9 0 1.6.7 1.6 1.6v12.6L10 13.6l-5.5 3.5V4.5c0-.9.7-1.6 1.6-1.6Z"/></svg>';

  function cartToast(text) {
    var body = document.querySelector('.ia-sliding-cart .ia-cart-body');
    if (!body) return;
    var toast = document.querySelector('.ex-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ex-cart-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = BOOKMARK + '<span></span>';
    toast.querySelector('span').textContent = text;
    toast.classList.add('is-in');
    clearTimeout(cartToast.timer);
    cartToast.timer = setTimeout(function () {
      toast.classList.remove('is-in');
    }, 2600);
  }

  function saveFromCart(button) {
    var li = button.closest('.ia-cart-list-item');
    var link = li && li.querySelector('a.ia-cart-item-title');
    if (!link) return;
    var url = new URL(link.getAttribute('href'), location.origin);
    var variantId = url.searchParams.get('variant');
    var handle = (url.pathname.split('/products/')[1] || '').split('/')[0];
    if (!variantId || !handle) return;
    button.classList.add('is-busy');
    var productId = null;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        productId = product.id;
        return new Promise(function (resolve, reject) {
          whenSwym(function (swat) {
            swat.addToWishList(
              { empi: Number(productId), epi: Number(variantId), du: location.origin + '/products/' + handle },
              resolve,
              reject
            );
          });
          // Ohne Bestätigung von Swym bleibt der Artikel im Warenkorb – nichts geht verloren.
          setTimeout(function () {
            reject(new Error('swym-timeout'));
          }, 6000);
        });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(variantId)) {
            line = cart.items[i];
            break;
          }
        }
        if (!line) return cart;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        try {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'ex-cart-save', data: { itemCount: cart.item_count, source: 'ex-cart-save' } };
          document.dispatchEvent(ev);
        } catch (e) {}
        try {
          if (typeof window.refreshOxifyCartDrawer === 'function') window.refreshOxifyCartDrawer({ showLoading: false });
        } catch (e) {}
        cartToast(t({ de: 'In deine Merkliste verschoben', en: 'Moved to your wishlist', pl: 'Przeniesiono do zapisanych', it: 'Spostato nei preferiti' }));
      })
      .catch(function () {
        button.classList.remove('is-busy');
      });
  }

  // Runde 25: Bild im Warenkorb läuft jetzt 80 × 120 px (2:3) – iCart lädt es nur 176 px hoch,
  // auf Retina-Displays zu weich. Auf 240 px Breite (= 360 px Höhe) anheben.
  function sharpenCartImages() {
    var imgs = document.querySelectorAll('.ia-sliding-cart img.ia-cart-item-image');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute('src') || '';
      // iCart setzt die Quelle beim Neuzeichnen zurück → jedes Mal prüfen (idempotent: danach steht width=240)
      if (/[?&]height=\d+/.test(src)) {
        img.setAttribute('src', src.replace(/([?&])height=\d+/, '$1width=240'));
      }
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    }
    var root = document.querySelector('.ia-sliding-cart');
    if (root && !root.hasAttribute('data-ex-sharp-watch')) {
      root.setAttribute('data-ex-sharp-watch', '1');
      new MutationObserver(sharpenCartImages).observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src']
      });
    }
  }

  function decorateCart() {
    sharpenCartImages();
    var items = document.querySelectorAll('.ia-sliding-cart .ia-cart-list-item');
    for (var i = 0; i < items.length; i++) {
      var foot = items[i].querySelector('.ia-cart-item-footer-container');
      if (!foot || foot.querySelector('.ex-cart-save')) continue;
      var slot = foot.lastElementChild;
      if (!slot) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ex-cart-save';
      b.innerHTML = BOOKMARK + '<span></span>';
      b.querySelector('span').textContent = t({ de: 'Merken', en: 'Save', pl: 'Zapisz', it: 'Salva' });
      b.setAttribute(
        'aria-label',
        t({ de: 'In die Merkliste verschieben', en: 'Move to wishlist', pl: 'Przenieś do zapisanych', it: 'Sposta nei preferiti' })
      );
      slot.classList.add('ex-cart-actions');
      slot.insertBefore(b, slot.firstChild);
    }
  }

  document.addEventListener('click', function (event) {
    var b = event.target.closest('.ex-cart-save');
    if (!b) return;
    event.preventDefault();
    event.stopPropagation();
    saveFromCart(b);
  });

  // ------------------------------------------------------------------
  // 5 · Kollektionsende: Zähler + Mehr laden
  // Fabric lädt die nächste Seite, sobald der Platzhalter [ref=viewMoreNext] sichtbar
  // wird. Der Platzhalter ist per CSS versteckt; „Mehr laden“ macht ihn kurz sichtbar.
  // ------------------------------------------------------------------
  function gridState(end) {
    var list = end.closest('results-list') || document;
    var grid = list.querySelector('.product-grid');
    if (!grid) return null;
    var per = Number(end.getAttribute('data-per')) || 24;
    var total = Number(end.getAttribute('data-total')) || 0;
    var pages = Number(end.getAttribute('data-pages')) || 1;
    var maxPage = 0;
    var items = grid.querySelectorAll('.product-grid__item[data-page]');
    for (var i = 0; i < items.length; i++) {
      var pg = Number(items[i].getAttribute('data-page')) || 0;
      if (pg > maxPage) maxPage = pg;
    }
    var shown = Math.min(total, maxPage * per);
    return { list: list, grid: grid, total: total, pages: pages, maxPage: maxPage, shown: shown };
  }

  function paintEnd(end) {
    var s = gridState(end);
    if (!s) return;
    var shownEl = end.querySelector('[data-ex-gridend-shown]');
    var fill = end.querySelector('[data-ex-gridend-fill]');
    var more = end.querySelector('[data-ex-gridend-more]');
    if (shownEl) shownEl.textContent = s.shown;
    if (fill) fill.style.width = (s.total ? (s.shown / s.total) * 100 : 100).toFixed(2) + '%';
    if (more) more.hidden = s.maxPage >= s.pages;
    end.classList.toggle('is-complete', s.maxPage >= s.pages);
  }

  function initGridEnd(end) {
    if (end.dataset.ready) return;
    end.dataset.ready = '1';
    var s = gridState(end);
    if (!s) return;
    s.list.classList.add('ex-loadmore');
    paintEnd(end);
    new MutationObserver(function () {
      s.list.classList.remove('ex-loadmore--go');
      var more = end.querySelector('[data-ex-gridend-more]');
      if (more) more.classList.remove('is-busy');
      paintEnd(end);
    }).observe(s.grid, { childList: true });
  }

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-ex-gridend-more]');
    if (!more) return;
    event.preventDefault();
    var end = more.closest('[data-ex-gridend]');
    var s = end && gridState(end);
    if (!s) return;
    more.classList.add('is-busy');
    s.list.classList.add('ex-loadmore--go');
    setTimeout(function () {
      s.list.classList.remove('ex-loadmore--go');
      more.classList.remove('is-busy');
    }, 6000);
  });

  // ------------------------------------------------------------------
  // 6 · Schalter „Verfügbar“ – nutzt das Verfügbarkeits-Häkchen des Filterformulars
  // (Ergebnis lädt ohne Seitenwechsel). Fallback: Link.
  // ------------------------------------------------------------------
  document.addEventListener('click', function (event) {
    var sw = event.target.closest('[data-ex-avail]');
    if (!sw) return;
    var scope = sw.closest('results-list') || document;
    var box =
      document.querySelector('#filters-drawer input[name="filter.v.availability"][value="1"]') ||
      scope.querySelector('input[name="filter.v.availability"][value="1"]');
    if (!box) return; // Link übernimmt
    event.preventDefault();
    var on = !sw.classList.contains('is-on');
    sw.classList.toggle('is-on', on);
    sw.setAttribute('aria-checked', on ? 'true' : 'false');
    box.click();
  });

  // ------------------------------------------------------------------
  // 7 · Kollektionstext (SEO) aufklappen
  // ------------------------------------------------------------------
  function initText(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var body = root.querySelector('[data-ex-ctext-body]');
    var more = root.querySelector('[data-ex-ctext-more]');
    if (!body || !more) return;
    if (body.scrollHeight <= body.clientHeight + 4) {
      root.classList.add('is-short');
      return;
    }
    more.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
    });
  }

  // ------------------------------------------------------------------
  // 8 · Produktanzahl am Kollektionstitel (Runde 20) – folgt dem Filter ohne Seitenwechsel
  // ------------------------------------------------------------------
  function syncCount() {
    var src = document.querySelector('[data-ex-count-src]');
    var n = document.querySelector('[data-ex-count-n]');
    if (!src || !n) return;
    var v = src.getAttribute('data-ex-count-src');
    if (v && n.textContent !== v) {
      n.textContent = v;
      var wrap = n.closest('[data-ex-count]');
      if (wrap) wrap.setAttribute('aria-label', v);
    }
  }


  // ------------------------------------------------------------------
  // 8 · Benachrichtigungs-Fenster (Privy): Produkt, Bild und gewählte Größe
  //     als Kontext über dem Hinweistext (Optik: excentred-master.css 58)
  // ------------------------------------------------------------------
  var SIZE_RE = /size|gr(ö|oe|ö)(ß|ss)e|rozmiar|taglia/i;

  function notifyContext() {
    var fly = document.querySelector('#privy-widget .privy-widget-flyout');
    if (!fly) return;
    var slot = fly.querySelector('.description-slot');
    var details = document.querySelector('.product-details');
    if (!slot || !details) return;
    var h1 = details.querySelector('h1');
    var title = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    var parts = [];
    // Runde 44: gewählte Werte aus der nativen Auswahl (fieldset data-ex-name + gewähltes Radio)
    var sets = details.querySelectorAll('variant-picker fieldset[data-ex-name]');
    for (var i = 0; i < sets.length; i++) {
      var chk = sets[i].querySelector('input:checked');
      var v = chk ? chk.value : '';
      if (!v) continue;
      var name = sets[i].getAttribute('data-ex-name') || '';
      // Sets: „T-SHIRT (SIZE)“ → „T-SHIRT S“ statt zweimal „Größe“ (Runde 29)
      var part = name.match(/^(.+?)\s*\((?:size|gr(?:ö|oe)(?:ss|ß)e|rozmiar|taglia)\)\s*$/i);
      if (part) parts.push(part[1].trim() + ' ' + v);
      else parts.push(SIZE_RE.test(name) ? t({ de: 'Größe', en: 'Size', pl: 'Rozmiar', it: 'Taglia' }) + ' ' + v : v);
    }
    var ctx = title + (parts.length ? '\n' + parts.join(' · ') : '');
    if (ctx && slot.getAttribute('data-ex-ctx') !== ctx) slot.setAttribute('data-ex-ctx', ctx);
    var img =
      details.querySelector('variant-picker .ex-vo--image input:checked + .ex-vo__img img') ||
      document.querySelector('.product-information media-gallery img');
    if (img) {
      var src = img.currentSrc || img.src || '';
      if (src) {
        src = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var val = 'url("' + src.replace(/"/g, '%22') + '")';
        if (slot.style.getPropertyValue('--ex-thumb') !== val) slot.style.setProperty('--ex-thumb', val);
      }
    }
  }

  // ------------------------------------------------------------------
  // 9 · Runde 28 · Warenkorb (iCart / Oxify)
  //   a) Optionsname „CHOOSE YOUR STYLE“ → „STYLE“ (nur im Warenkorb)
  //   b) Goodie-Slider: Pfeile am Anfang/Ende inaktiv, kein Leerlauf
  //   c) Goodie-Kopf „Dein Gratis-Goodie“ + Hinweiszeile, „Gratis“/„Auswählen“ übersetzt (Runde 29)
  //   d) Goodie-Auswahlfenster: „Gratis“ statt Preis, Button übersetzt
  // Optik: excentred-master.css, Abschnitt 64
  // ------------------------------------------------------------------
  var STYLE_RE = /^\s*(choose your style|wybierz (?:sw[oó]j )?styl|scegli (?:il tuo )?stile)\s*:/i;
  var STYLE_WORD_RE = /(choose your style|wybierz (?:sw[oó]j )?styl|scegli (?:il tuo )?stile)/i;
  var STYLE_WORD = function () {
    return t({ de: 'Style', en: 'Style', pl: 'Styl', it: 'Stile' });
  };

  // Der Text kann in mehreren Textknoten stehen („CHOOSE YOUR STYLE“ · „: “ · „WHITE PATCH“) –
  // geprüft wird der ganze Untertitel, ersetzt nur die Phrase im jeweiligen Knoten.
  function shortStyle(root) {
    var subs = root.querySelectorAll('.ia-cart-item-subtitle');
    for (var i = 0; i < subs.length; i++) {
      if (!STYLE_RE.test(subs[i].textContent)) continue;
      var walker = document.createTreeWalker(subs[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (STYLE_WORD_RE.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(STYLE_WORD_RE, STYLE_WORD());
          break;
        }
      }
    }
  }

  function giftScroller(root) {
    var s = root.querySelector('.ia-free-gift-slider');
    var c = root.querySelector('.ia-free-gift-slider-container');
    if (s && s.scrollWidth > s.clientWidth + 2) return s;
    if (c && c.scrollWidth > c.clientWidth + 2) return c;
    return s || c;
  }

  function giftArrows(root) {
    var sc = giftScroller(root);
    var arrows = root.querySelectorAll('.ia-free-gift-arrow-button');
    if (!sc || arrows.length < 2) return;
    var max = sc.scrollWidth - sc.clientWidth - 4;
    var atStart = sc.scrollLeft <= 4;
    var atEnd = sc.scrollLeft >= max;
    arrows[0].classList.toggle('is-off', atStart);
    arrows[1].classList.toggle('is-off', atEnd || max <= 0);
    arrows[0].setAttribute('aria-disabled', atStart ? 'true' : 'false');
    arrows[1].setAttribute('aria-disabled', atEnd || max <= 0 ? 'true' : 'false');
    if (!sc.hasAttribute('data-ex-gift-watch')) {
      sc.setAttribute('data-ex-gift-watch', '1');
      sc.addEventListener(
        'scroll',
        function () {
          var r = sc.closest('.ia-sliding-cart');
          if (r) giftArrows(r);
        },
        { passive: true }
      );
    }
  }

  // Runde 29: Kopf ruhiger – Geschenk-Icon (CSS) + eigener Titel, eine graue Hinweiszeile,
  // „FREE“ → „Gratis“, „CHOOSE“ → „Auswählen“. Nur Textwerte werden getauscht (nodeValue),
  // damit die App ihre Knoten behält.
  function setText(el, value) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue.trim()) continue;
      if (node.nodeValue !== value) node.nodeValue = value;
      return;
    }
  }

  function giftHint(root) {
    var comp = root.querySelector('.ia-free-gift-selection-component');
    if (!comp) return;
    comp.classList.add('ex-gift');
    var title = comp.querySelector('.ia-free-gift-selection-title');
    if (!title) return;
    // Titel = erster eigener Textknoten (nicht in den Pfeilen)
    for (var n = title.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        // Runde 32: „Geschenk“ statt „Goodie“ – versteht jeder, passt auch für die Mystery Box
        var tt = t({ de: 'Dein Gratis-Geschenk', en: 'Your free gift', pl: 'Twój prezent', it: 'Il tuo regalo' });
        if (n.nodeValue !== tt) n.nodeValue = tt;
        break;
      }
    }
    var free = t({ de: 'Gratis', en: 'Free', pl: 'Gratis', it: 'Gratis' });
    var pick = t({ de: 'Auswählen', en: 'Choose', pl: 'Wybierz', it: 'Scegli' });
    var prices = comp.querySelectorAll('.ia-gift-selection-item-free-price');
    for (var i = 0; i < prices.length; i++) setText(prices[i], free);
    var btns = comp.querySelectorAll('.ia-gift-selection-button-text');
    for (var j = 0; j < btns.length; j++) setText(btns[j], pick);
    // Runde 30: „(3-PACK)“ nicht am Bindestrich umbrechen (geschützter Bindestrich U+2011).
    var names = comp.querySelectorAll('.ia-gift-selection-item-title');
    for (var k = 0; k < names.length; k++) {
      var nm = names[k].textContent;
      var fixed = nm.replace(/([0-9A-Za-zÄÖÜäöü])-([0-9A-Za-zÄÖÜäöü])/g, '$1\u2011$2');
      if (fixed !== nm) setText(names[k], fixed);
    }
    if (comp.querySelector('.ex-gift-hint')) return;
    var p = document.createElement('p');
    p.className = 'ex-gift-hint';
    p.textContent = t({
      de: 'Zu deiner Bestellung – such dir eins aus.',
      en: 'With your order – pick one.',
      pl: 'Do zamówienia – wybierz jeden.',
      it: 'Con il tuo ordine – scegline uno.'
    });
    title.insertAdjacentElement('afterend', p);
  }

  function giftSheet(root) {
    var sheet = root.querySelector('.ia-choose-variant-bs-container');
    if (!sheet || !root.hasAttribute('data-ex-gift-open')) return;
    sheet.classList.add('ex-gift-sheet');
    var price = sheet.querySelector('.ia-choose-variant-bs-pricing');
    var free = t({ de: 'Gratis', en: 'Free', pl: 'Gratis', it: 'Gratis' });
    if (price && price.textContent !== free) price.textContent = free;
    var btn = sheet.querySelector('.ia-choose-variant-bs-button');
    var label = t({ de: 'Geschenk übernehmen', en: 'Add gift', pl: 'Dodaj prezent', it: 'Aggiungi regalo' });
    if (btn && btn.textContent !== label) btn.textContent = label;
  }

  // Runde 32: „FREE GOODIE“ aus den App-Texten im Warenkorb als „FREE GIFT“ (Belohnungs-Leiste,
  // Hinweis „ADD … FOR FREE GOODIE“, Etikett am Artikel, Rabatt-Etikett unten).
  function renameGoodie(root) {
    var els = root.querySelectorAll(
      '.ia-rewards-icon-description, .ia-rewards-banner-title, .ia-cart-item-discount-title, .ia-applied-discount-code-container'
    );
    for (var i = 0; i < els.length; i++) {
      var walker = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (!/goodie/i.test(node.nodeValue)) continue;
        var v = node.nodeValue.replace(/GOODIES/g, 'GIFTS').replace(/GOODIE/g, 'GIFT').replace(/Goodies/g, 'Gifts').replace(/Goodie/g, 'Gift').replace(/goodie/g, 'gift');
        if (v !== node.nodeValue) node.nodeValue = v;
      }
    }
  }

  // Runde 31: leerer Warenkorb in der Shop-Sprache statt App-Englisch
  function emptyTexts(root) {
    var title = root.querySelector('.ia-cart-empty-text');
    if (!title) return;
    setText(title, t({ de: 'Dein Warenkorb ist leer', en: 'Your cart is empty', pl: 'Twój koszyk jest pusty', it: 'Il tuo carrello è vuoto' }));
    setText(root.querySelector('.ia-cart-empty-description'), t({
      de: 'Entdecke die neuesten Drops.',
      en: 'Discover the latest drops.',
      pl: 'Odkryj najnowsze dropy.',
      it: 'Scopri gli ultimi drop.'
    }));
    setText(root.querySelector('.ia-cart-empty-button'), t({ de: 'Jetzt shoppen', en: 'Shop now', pl: 'Kupuj teraz', it: 'Acquista ora' }));
  }

  function cartTweaks() {
    var root = document.querySelector('.ia-sliding-cart');
    if (!root) return;
    shortStyle(root);
    giftArrows(root);
    giftHint(root);
    giftSheet(root);
    emptyTexts(root);
    renameGoodie(root);
    freeLines(root);
    sheetWas(root);
    zoomHints(root);
    codeBox(root);
    if (!root.hasAttribute('data-ex-r28-watch')) {
      root.setAttribute('data-ex-r28-watch', '1');
      var busy = 0;
      new MutationObserver(function () {
        if (busy) return;
        busy = requestAnimationFrame(function () {
          busy = 0;
          shortStyle(root);
          giftArrows(root);
          giftHint(root);
          emptyTexts(root);
          renameGoodie(root);
          giftSheet(root);
          freeLines(root);
          sheetWas(root);
          zoomHints(root);
          codeBox(root);
        });
      }).observe(root, { subtree: true, childList: true, characterData: true });
    }
  }

  // Klick auf „Choose“ merkt sich, dass das nächste Auswahlfenster ein Goodie ist;
  // Klick auf einen inaktiven Pfeil läuft ins Leere statt ins Nichts zu scrollen.
  document.addEventListener(
    'click',
    function (event) {
      var root = event.target.closest && event.target.closest('.ia-sliding-cart');
      if (!root) return;
      if (event.target.closest('.ex-zoom')) return;
      var choose = event.target.closest('.ia-gift-selection-add-to-cart-button');
      if (choose) {
        root.setAttribute('data-ex-gift-open', '1');
        // R63: Normalpreis der angetippten Karte merken → Streichpreis im Auswahlfenster
        var card = choose.closest('.ia-gift-selection-item-container');
        var orig = card && card.querySelector('.ia-gift-selection-item-original-price');
        if (orig && orig.textContent.trim()) root.setAttribute('data-ex-gift-was', orig.textContent.trim());
        else root.removeAttribute('data-ex-gift-was');
      } else if (event.target.closest('.ia-free-gift-arrow-button.is-off')) {
        event.preventDefault();
        event.stopPropagation();
      } else if (zoomFromClick(root, event.target)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // ------------------------------------------------------------------
  // 9b · Runde 63 · Warenkorb: Gratis-Artikel mit Streichpreis, Großansicht der Geschenke
  //   a) Gratis-Zeile (iCart-Belohnung): durchgestrichener Ladenpreis über „Gratis“. Wert aus
  //      /cart.js (original_line_price = Ladenpreis × Menge, bewusst nicht der Vergleichspreis)
  //   b) „Merken“ entfällt bei Gratis-Zeilen (CSS, ein Geschenk wandert nicht in die Merkliste)
  //   c) Größen-Auswahlfenster eines Geschenks: Streichpreis vor „Gratis“ (Wert der angetippten Karte)
  //   d) Antippen eines Geschenkbilds (Karussell, Auswahlfenster, Gratis-Zeile) → Großansicht
  //      im Warenkorb, Schließen per Tippen, Kreuz oder Esc; aus dem Karussell mit „Auswählen“
  // Optik: excentred-master.css, Abschnitt 80
  // ------------------------------------------------------------------
  var exCart = null;
  var exCartAt = 0;
  var exCartBusy = null;
  var exCartForced = 0;

  function cartData(force) {
    if (!force && exCart && Date.now() - exCartAt < 4000) return Promise.resolve(exCart);
    if (exCartBusy) return exCartBusy;
    exCartBusy = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        exCart = c;
        exCartAt = Date.now();
        exCartBusy = null;
        return c;
      })
      .catch(function () {
        exCartBusy = null;
        return null;
      });
    return exCartBusy;
  }

  // Betrag im Format, das der Warenkorb gerade zeigt („€17“, „€17,50“, „76 zł“): Vorlage ist ein vorhandener Preis
  function moneyLike(cents, root) {
    var sample = root.querySelector(
      '.ia-cart-item-original-price, .ia-cart-item-discounted-price, .ia-gift-selection-item-original-price'
    );
    var txt = sample ? sample.textContent.trim() : '';
    var numRe = /\d(?:[\d.,\u00a0\u202f ]*\d)?/;
    var hit = txt.match(numRe);
    var abs = Math.abs(cents);
    var rest = abs % 100;
    var dec = hit && /[.,]\d{2}$/.test(hit[0]) ? hit[0].charAt(hit[0].length - 3) : LANG === 'en' ? '.' : ',';
    var num = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? '.' : ',');
    if (rest) num += dec + (rest < 10 ? '0' : '') + rest;
    if (hit) return txt.replace(numRe, num);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: (exCart && exCart.currency) || 'EUR',
        minimumFractionDigits: rest ? 2 : 0,
        maximumFractionDigits: 2
      }).format(abs / 100);
    } catch (e) {
      return num;
    }
  }

  function wasEl(text) {
    var was = document.createElement('span');
    was.className = 'ex-gift-was';
    var hid = document.createElement('span');
    hid.className = 'visually-hidden';
    hid.textContent = t({ de: 'statt ', en: 'instead of ', pl: 'zamiast ', it: 'invece di ' });
    var s = document.createElement('s');
    s.textContent = text;
    was.appendChild(hid);
    was.appendChild(s);
    return was;
  }

  function lineVariant(li) {
    var a = li && li.querySelector('a.ia-cart-item-title');
    if (!a) return null;
    try {
      return new URL(a.getAttribute('href'), location.origin).searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  function freeLines(root) {
    var badges = root.querySelectorAll('.ia-cart-list-item .ia-cart-item-free-gift-container');
    if (!badges.length) return;
    var free = t({ de: 'Gratis', en: 'Free', pl: 'Gratis', it: 'Gratis' });
    var todo = [];
    for (var i = 0; i < badges.length; i++) {
      setText(badges[i], free);
      if (!badges[i].parentNode.querySelector('.ex-gift-was')) todo.push(badges[i]);
    }
    if (!todo.length) return;
    cartData(false).then(function (cart) {
      if (!cart || !cart.items) return;
      var missing = false;
      todo.forEach(function (badge) {
        if (!badge.isConnected || badge.parentNode.querySelector('.ex-gift-was')) return;
        var vid = lineVariant(badge.closest('.ia-cart-list-item'));
        var line = null;
        for (var k = 0; k < cart.items.length; k++) {
          var it = cart.items[k];
          if (String(it.variant_id) === String(vid) && it.final_line_price === 0) {
            line = it;
            break;
          }
        }
        if (!line) {
          missing = true;
          return;
        }
        var cents = line.original_line_price || line.original_price * line.quantity;
        if (cents > 0) badge.parentNode.insertBefore(wasEl(moneyLike(cents, root)), badge);
      });
      // Geschenk eben erst dazugekommen und noch nicht im gemerkten Warenkorb → einmal frisch laden
      if (missing && Date.now() - exCartForced > 3000) {
        exCartForced = Date.now();
        exCartAt = 0;
        setTimeout(function () {
          freeLines(root);
        }, 400);
      }
    });
  }

  function sheetWas(root) {
    var sheet = root.querySelector('.ia-choose-variant-bs-container');
    var was = root.getAttribute('data-ex-gift-was');
    if (!sheet || !was || !root.hasAttribute('data-ex-gift-open')) return;
    var parent = sheet.querySelector('.ia-choose-variant-bs-price-parent');
    var price = parent && parent.querySelector('.ia-choose-variant-bs-pricing');
    if (!price) return;
    var have = parent.querySelector('.ex-gift-was');
    if (have && have.querySelector('s').textContent === was) return;
    if (have) have.remove();
    parent.insertBefore(wasEl(was), price);
  }

  var ZOOM_ICON =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="8.6" cy="8.6" r="5.4"/><path d="M12.6 12.6l4.4 4.4M8.6 6.4v4.4M6.4 8.6h4.4"/></svg>';

  function addHint(box, kind) {
    if (!box || box.querySelector(':scope > .ex-zoom-hint')) return;
    var h = document.createElement('span');
    h.className = 'ex-zoom-hint ex-zoom-hint--' + kind;
    h.setAttribute('aria-hidden', 'true');
    h.innerHTML = ZOOM_ICON;
    box.appendChild(h);
  }

  function zoomHints(root) {
    var i;
    var cards = root.querySelectorAll('.ia-gift-selection-item-container');
    for (i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('.ia-gift-selection-item-image')) addHint(cards[i], 'card');
    }
    if (root.hasAttribute('data-ex-gift-open')) {
      var det = root.querySelector('.ia-choose-variant-bs-details');
      if (det && det.querySelector('.ia-choose-variant-bs-details-image')) addHint(det, 'sheet');
    }
    var badges = root.querySelectorAll('.ia-cart-list-item .ia-cart-item-free-gift-container');
    for (i = 0; i < badges.length; i++) {
      var li = badges[i].closest('.ia-cart-list-item');
      var img = li && li.querySelector('img.ia-cart-item-image');
      if (img && img.parentElement) addHint(img.parentElement, 'line');
    }
  }

  function bigSrc(src) {
    if (!src) return src;
    try {
      var u = new URL(src, location.href);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', '900');
      u.pathname = u.pathname.replace(/_(?:\d+x\d*|\d*x\d+)(?=\.(?:jpe?g|png|webp|gif)$)/i, '');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  var zoomEl = null;
  var zoomBack = null;

  function zoomClose(now) {
    if (!zoomEl) return;
    var el = zoomEl;
    zoomEl = null;
    el.classList.remove('is-in');
    if (now) {
      el.remove();
    } else {
      setTimeout(function () {
        el.remove();
      }, 240);
    }
    if (zoomBack && zoomBack.isConnected) {
      try {
        zoomBack.focus({ preventScroll: true });
      } catch (e) {}
    }
    zoomBack = null;
  }

  function zoomOpen(root, img, data) {
    zoomClose(true);
    var el = document.createElement('div');
    el.className = 'ex-zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', data.title || t({ de: 'Großansicht', en: 'Enlarged view', pl: 'Powiększenie', it: 'Vista ingrandita' }));
    el.innerHTML =
      '<button type="button" class="ex-zoom__close"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.5 4.5l11 11M15.5 4.5l-11 11"/></svg></button>' +
      '<figure class="ex-zoom__fig"><div class="ex-zoom__media"><img class="ex-zoom__img" alt="" decoding="async"></div>' +
      '<figcaption class="ex-zoom__cap"><span class="ex-zoom__title"></span><span class="ex-zoom__price"></span></figcaption></figure>';
    el.querySelector('.ex-zoom__close').setAttribute('aria-label', t({ de: 'Schließen', en: 'Close', pl: 'Zamknij', it: 'Chiudi' }));
    var big = el.querySelector('.ex-zoom__img');
    big.alt = data.title || '';
    var low = img.currentSrc || img.src;
    big.src = low;
    var hi = bigSrc(low);
    if (hi && hi !== low) {
      var pre = new Image();
      pre.onload = function () {
        if (big.isConnected || el === zoomEl) big.src = hi;
      };
      pre.src = hi;
    }
    el.querySelector('.ex-zoom__title').textContent = data.title || '';
    var price = el.querySelector('.ex-zoom__price');
    if (data.was) price.appendChild(wasEl(data.was));
    var tag = document.createElement('span');
    tag.className = 'ex-zoom__free';
    tag.textContent = t({ de: 'Gratis', en: 'Free', pl: 'Gratis', it: 'Gratis' });
    price.appendChild(tag);
    if (data.choose) {
      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'ex-zoom__cta';
      cta.textContent = t({ de: 'Auswählen', en: 'Choose', pl: 'Wybierz', it: 'Scegli' });
      cta.addEventListener('click', function (event) {
        event.stopPropagation();
        var target = data.choose;
        zoomClose(true);
        if (target && target.isConnected) target.click();
      });
      el.querySelector('.ex-zoom__fig').appendChild(cta);
    }
    // Klicks bleiben in der Großansicht – iCart soll sie nicht als „außerhalb“ werten (Fenster/Warenkorb zu)
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      el.addEventListener(
        type,
        function (event) {
          event.stopPropagation();
        },
        { passive: true }
      );
    });
    el.addEventListener('click', function (event) {
      event.stopPropagation();
      zoomClose(false);
    });
    root.appendChild(el);
    zoomEl = el;
    zoomBack = img;
    void el.offsetWidth; // Startzustand festhalten, dann einblenden (ohne rAF: läuft auch in Hintergrund-Tabs)
    el.classList.add('is-in');
    try {
      el.querySelector('.ex-zoom__close').focus({ preventScroll: true });
    } catch (e) {}
  }

  function zoomFromClick(root, target) {
    var card = target.closest('.ia-gift-selection-item-container');
    if (card && target.closest('.ia-gift-selection-item-image, .ex-zoom-hint--card')) {
      var cimg = card.querySelector('.ia-gift-selection-item-image');
      var title = card.querySelector('.ia-gift-selection-item-title');
      var orig = card.querySelector('.ia-gift-selection-item-original-price');
      if (!cimg) return false;
      zoomOpen(root, cimg, {
        title: title ? title.textContent.trim() : '',
        was: orig ? orig.textContent.trim() : '',
        choose: card.querySelector('.ia-gift-selection-add-to-cart-button')
      });
      return true;
    }
    var simg = target.closest('.ia-choose-variant-bs-details-image, .ex-zoom-hint--sheet');
    if (simg && simg.classList.contains('ex-zoom-hint')) {
      simg = simg.parentElement.querySelector('.ia-choose-variant-bs-details-image');
    }
    if (simg && root.hasAttribute('data-ex-gift-open')) {
      var st = root.querySelector('.ia-choose-variant-bs-details .ia-cart-item-title');
      zoomOpen(root, simg, { title: st ? st.textContent.trim() : '', was: root.getAttribute('data-ex-gift-was') || '' });
      return true;
    }
    var limg = target.closest('img.ia-cart-item-image, .ex-zoom-hint--line');
    if (limg && limg.classList.contains('ex-zoom-hint')) limg = limg.parentElement.querySelector('img.ia-cart-item-image');
    var li = limg && limg.closest('.ia-cart-list-item');
    if (li && li.querySelector('.ia-cart-item-free-gift-container')) {
      var lt = li.querySelector('a.ia-cart-item-title');
      var lw = li.querySelector('.ex-gift-was s');
      zoomOpen(root, limg, { title: lt ? lt.textContent.trim() : '', was: lw ? lw.textContent.trim() : '' });
      return true;
    }
    return false;
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (!zoomEl || event.key !== 'Escape') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      zoomClose(false);
    },
    true
  );

  // ------------------------------------------------------------------
  // 9c · Runde 64 · Code-Feld im Warenkorb: Rabattcode ODER Gutschein in einem Feld
  //   Läuft über die Storefront-API (ohne Token, gleicher Warenkorb wie /cart.js und Checkout):
  //   1) Rabattcode: cartDiscountCodesUpdate mit allen bisherigen Codes + neuem Code.
  //      Greift er → iCart zeigt ihn als Etikett mit ✕ und rechnet die Summe neu.
  //      Greift er (noch) nicht, sagt Shopify warum (warnings[].code) → eigener Text in 4 Sprachen.
  //      Versand-/Mindestwert-Codes bleiben gespeichert (Etikett „im Checkout“ / „noch nicht aktiv“).
  //   2) Kein Rabattcode gefunden → als Geschenkgutschein versuchen (cartGiftCardCodesAdd).
  //      Gutscheine sind eine Zahlart: Die Zwischensumme bleibt, der Betrag wird an der Kasse
  //      verrechnet. Eigenes Etikett „Gutschein ••••1234 −€25“ mit ✕.
  //   Optik: excentred-master.css, Abschnitt 81
  // ------------------------------------------------------------------
  var CODE_API = '/api/2026-07/graphql.json';
  var CODE_KEY = 'ex-redeem-pending';
  var codeState = { value: '', msg: '', tone: '', gifts: [], busy: false, lastSync: 0 };
  var codeSyncTimer = 0;
  var codeMsgTimer = 0;

  var CODE_T = {
    ph: { de: 'Rabattcode oder Gutschein', en: 'Discount code or gift card', pl: 'Kod rabatowy lub karta podarunkowa', it: 'Codice sconto o buono regalo' },
    btn: { de: 'Einlösen', en: 'Apply', pl: 'Zastosuj', it: 'Applica' },
    ok: { de: 'Code [c] eingelöst.', en: 'Code [c] applied.', pl: 'Kod [c] zastosowany.', it: 'Codice [c] applicato.' },
    gift: {
      de: 'Gutschein eingelöst: [a] werden an der Kasse verrechnet.',
      en: 'Gift card applied: [a] will be deducted at checkout.',
      pl: 'Karta podarunkowa dodana: [a] zostanie odliczone przy kasie.',
      it: 'Buono regalo applicato: [a] verranno scalati al checkout.'
    },
    giftOk: { de: 'Gutschein eingelöst.', en: 'Gift card applied.', pl: 'Karta podarunkowa dodana.', it: 'Buono regalo applicato.' },
    already: { de: 'Dieser Code ist schon eingelöst.', en: 'This code is already applied.', pl: 'Ten kod jest już zastosowany.', it: 'Questo codice è già applicato.' },
    notFound: {
      de: 'Code nicht gefunden. Bitte prüfe die Schreibweise.',
      en: 'Code not found. Please check the spelling.',
      pl: 'Nie znaleziono kodu. Sprawdź pisownię.',
      it: 'Codice non trovato. Controlla l’ortografia.'
    },
    inactive: {
      de: 'Dieser Code ist abgelaufen oder noch nicht aktiv.',
      en: 'This code has expired or isn’t active yet.',
      pl: 'Ten kod wygasł lub nie jest jeszcze aktywny.',
      it: 'Questo codice è scaduto o non ancora attivo.'
    },
    used: { de: 'Dieser Code wurde bereits eingelöst.', en: 'This code has already been used.', pl: 'Ten kod został już wykorzystany.', it: 'Questo codice è già stato utilizzato.' },
    customer: {
      de: 'Dieser Code gilt nur für bestimmte Kundenkonten. Melde dich im Checkout an.',
      en: 'This code is only valid for certain customer accounts. Log in at checkout.',
      pl: 'Ten kod obowiązuje tylko dla wybranych kont. Zaloguj się przy kasie.',
      it: 'Questo codice vale solo per alcuni account. Accedi al checkout.'
    },
    minValue: {
      de: 'Mindestbestellwert noch nicht erreicht. Der Code ist gespeichert und greift automatisch.',
      en: 'Minimum order value not reached yet. The code is saved and applies automatically.',
      pl: 'Minimalna wartość zamówienia nie została osiągnięta. Kod jest zapisany i zadziała automatycznie.',
      it: 'Importo minimo non ancora raggiunto. Il codice è salvato e si applica automaticamente.'
    },
    minQty: {
      de: 'Mindestanzahl an Artikeln noch nicht erreicht. Der Code ist gespeichert und greift automatisch.',
      en: 'Minimum number of items not reached yet. The code is saved and applies automatically.',
      pl: 'Minimalna liczba produktów nie została osiągnięta. Kod jest zapisany i zadziała automatycznie.',
      it: 'Numero minimo di articoli non ancora raggiunto. Il codice è salvato e si applica automaticamente.'
    },
    items: {
      de: 'Dieser Code gilt nicht für die Artikel in deinem Warenkorb.',
      en: 'This code doesn’t apply to the items in your cart.',
      pl: 'Ten kod nie dotyczy produktów w Twoim koszyku.',
      it: 'Questo codice non vale per gli articoli nel carrello.'
    },
    shipping: {
      de: 'Code gespeichert. Der Versandrabatt wird im Checkout abgezogen.',
      en: 'Code saved. The shipping discount is applied at checkout.',
      pl: 'Kod zapisany. Rabat na dostawę zostanie naliczony przy kasie.',
      it: 'Codice salvato. Lo sconto sulla spedizione viene applicato al checkout.'
    },
    honour: {
      de: 'Code gespeichert – er wird im Checkout geprüft.',
      en: 'Code saved – it will be checked at checkout.',
      pl: 'Kod zapisany – zostanie sprawdzony przy kasie.',
      it: 'Codice salvato – verrà verificato al checkout.'
    },
    giftOff: {
      de: 'Gutscheine löst du bitte direkt im Checkout ein.',
      en: 'Please apply gift cards directly at checkout.',
      pl: 'Karty podarunkowe wpisz bezpośrednio przy kasie.',
      it: 'Inserisci i buoni regalo direttamente al checkout.'
    },
    error: { de: 'Das hat nicht geklappt. Bitte versuch es noch einmal.', en: 'Something went wrong. Please try again.', pl: 'Coś poszło nie tak. Spróbuj ponownie.', it: 'Qualcosa è andato storto. Riprova.' },
    atCheckout: { de: 'im Checkout', en: 'at checkout', pl: 'przy kasie', it: 'al checkout' },
    notYet: { de: 'noch nicht aktiv', en: 'not active yet', pl: 'jeszcze nieaktywny', it: 'non ancora attivo' },
    giftLabel: { de: 'Gutschein', en: 'Gift card', pl: 'Karta podarunkowa', it: 'Buono regalo' },
    remove: { de: 'Entfernen', en: 'Remove', pl: 'Usuń', it: 'Rimuovi' }
  };

  function ct(key, rep) {
    var s = t(CODE_T[key]);
    if (rep) for (var k in rep) s = s.split('[' + k + ']').join(rep[k]);
    return s;
  }

  // Warnung → [Text, behalten?, Etikett]
  var CODE_WARN = {
    DISCOUNT_NOT_FOUND: ['notFound', false],
    DISCOUNT_CURRENTLY_INACTIVE: ['inactive', false],
    DISCOUNT_USAGE_LIMIT_REACHED: ['used', false],
    DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED: ['used', false],
    DISCOUNT_CUSTOMER_NOT_ELIGIBLE: ['customer', false],
    DISCOUNT_ELIGIBLE_CUSTOMER_MISSING: ['customer', false],
    DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE: ['items', false],
    DISCOUNT_PURCHASE_NOT_IN_RANGE: ['minValue', true, 'notYet'],
    DISCOUNT_QUANTITY_NOT_IN_RANGE: ['minQty', true, 'notYet'],
    DISCOUNT_NO_ENTITLED_LINE_ITEMS: ['items', true, 'notYet'],
    DISCOUNT_NO_ENTITLED_SHIPPING_LINES: ['shipping', true, 'atCheckout'],
    DISCOUNT_CODE_NOT_HONOURED: ['honour', true, 'atCheckout']
  };

  function codePending() {
    try {
      return JSON.parse(sessionStorage.getItem(CODE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function codePendingSet(map) {
    try {
      sessionStorage.setItem(CODE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function sfCall(query, variables) {
    return fetch(CODE_API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('sf ' + r.status);
        return r.json();
      })
      .then(function (j) {
        if (!j || j.errors || !j.data) throw new Error('sf errors');
        return j.data;
      });
  }

  function cartGid() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        exCart = cart;
        exCartAt = Date.now();
        return { id: 'gid://shopify/Cart/' + cart.token, cart: cart };
      });
  }

  var CART_FIELDS =
    'id discountCodes { code applicable } appliedGiftCards { id lastCharacters presentmentAmountUsed { amount currencyCode } }';
  var Q_CODE_CART = 'query($id: ID!) { cart(id: $id) { ' + CART_FIELDS + ' } }';
  var M_CODES =
    'mutation($id: ID!, $codes: [String!]!) { cartDiscountCodesUpdate(cartId: $id, discountCodes: $codes) { cart { ' +
    CART_FIELDS +
    ' } userErrors { code message } warnings { code message } } }';
  var M_GIFT_ADD =
    'mutation($id: ID!, $codes: [String!]!) { cartGiftCardCodesAdd(cartId: $id, giftCardCodes: $codes) { cart { ' +
    CART_FIELDS +
    ' } userErrors { code message } warnings { code message } } }';
  var M_GIFT_RM =
    'mutation($id: ID!, $ids: [ID!]!) { cartGiftCardCodesRemove(cartId: $id, appliedGiftCardIds: $ids) { cart { ' +
    CART_FIELDS +
    ' } userErrors { code message } } }';

  function sameCode(a, b) {
    return String(a).trim().toUpperCase() === String(b).trim().toUpperCase();
  }

  function giftAmount(g, root) {
    var m = g && g.presentmentAmountUsed;
    if (!m) return '';
    return moneyLike(Math.round(parseFloat(m.amount) * 100), root);
  }

  // Merkt sich Gutscheine + gespeicherte (noch nicht greifende) Codes aus der Antwort
  function codeAdopt(cart) {
    if (!cart) return;
    codeState.gifts = cart.appliedGiftCards || [];
    var pend = codePending();
    var keep = {};
    (cart.discountCodes || []).forEach(function (d) {
      for (var k in pend) {
        if (sameCode(k, d.code) && !d.applicable) keep[k] = pend[k];
      }
    });
    codePendingSet(keep);
  }

  function codeRefreshCart() {
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { sourceId: 'ex-redeem', data: { source: 'ex-redeem' } };
      document.dispatchEvent(ev);
    } catch (e) {}
    try {
      if (typeof window.refreshOxifyCartDrawer === 'function') window.refreshOxifyCartDrawer({ showLoading: false });
    } catch (e) {}
  }

  function codeMsg(text, tone) {
    codeState.msg = text || '';
    codeState.tone = tone || '';
    clearTimeout(codeMsgTimer);
    if (text && tone === 'ok') {
      codeMsgTimer = setTimeout(function () {
        codeState.msg = '';
        codeRender();
      }, 6000);
    }
    codeRender();
  }

  function codeBusy(on) {
    codeState.busy = !!on;
    codeRender();
  }

  function codeChip(label, sub, amount, onRemove, kind) {
    var chip = document.createElement('span');
    chip.className = 'ex-redeem__chip ex-redeem__chip--' + kind;
    var l = document.createElement('span');
    l.className = 'ex-redeem__chip-label';
    l.textContent = label;
    chip.appendChild(l);
    if (sub) {
      var s = document.createElement('span');
      s.className = 'ex-redeem__chip-sub';
      s.textContent = sub;
      chip.appendChild(s);
    }
    if (amount) {
      var a = document.createElement('span');
      a.className = 'ex-redeem__chip-amt';
      a.textContent = '−' + amount;
      chip.appendChild(a);
    }
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'ex-redeem__chip-x';
    x.setAttribute('aria-label', ct('remove') + ': ' + label);
    x.textContent = '✕';
    x.addEventListener('click', onRemove);
    chip.appendChild(x);
    return chip;
  }

  function codeRender() {
    var box = document.querySelector('.ia-sliding-cart .ex-redeem');
    if (!box) return;
    var root = box.closest('.ia-sliding-cart');
    var input = box.querySelector('.ex-redeem__input');
    var btn = box.querySelector('.ex-redeem__btn');
    if (document.activeElement !== input && input.value !== codeState.value) input.value = codeState.value;
    var has = !!codeState.value.trim();
    btn.disabled = !has || codeState.busy;
    input.disabled = codeState.busy;
    box.classList.toggle('is-filled', has);
    box.classList.toggle('is-busy', codeState.busy);
    var msg = box.querySelector('.ex-redeem__msg');
    if (msg.textContent !== codeState.msg) msg.textContent = codeState.msg;
    msg.hidden = !codeState.msg;
    msg.setAttribute('data-tone', codeState.tone || '');
    // Etiketten: Gutscheine + gespeicherte Codes (angewendete Rabattcodes zeigt iCart selbst)
    var chips = box.querySelector('.ex-redeem__chips');
    var sig = JSON.stringify([codeState.gifts, codePending()]);
    if (chips.getAttribute('data-sig') === sig) return;
    chips.setAttribute('data-sig', sig);
    chips.textContent = '';
    codeState.gifts.forEach(function (g) {
      chips.appendChild(
        codeChip(ct('giftLabel') + ' ••••' + g.lastCharacters, '', giftAmount(g, root), function () {
          codeGiftRemove(g.id);
        }, 'gift')
      );
    });
    var pend = codePending();
    Object.keys(pend).forEach(function (code) {
      chips.appendChild(
        codeChip(code, ct(pend[code] || 'atCheckout'), '', function () {
          codeDiscountRemove(code);
        }, 'pending')
      );
    });
    chips.hidden = !chips.childNodes.length;
  }

  function codeSync(force) {
    if (!force && Date.now() - codeState.lastSync < 1500) return;
    clearTimeout(codeSyncTimer);
    codeSyncTimer = setTimeout(function () {
      codeState.lastSync = Date.now();
      cartGid()
        .then(function (c) {
          if (!c.cart.item_count) return null;
          return sfCall(Q_CODE_CART, { id: c.id });
        })
        .then(function (d) {
          if (d && d.cart) codeAdopt(d.cart);
          codeRender();
        })
        .catch(function () {});
    }, force ? 0 : 250);
  }

  function codeSubmit() {
    var raw = codeState.value.trim().replace(/\s+/g, ' ');
    if (!raw || codeState.busy) return;
    var code = raw.toUpperCase();
    codeMsg('', '');
    codeBusy(true);
    var ctx;
    cartGid()
      .then(function (c) {
        ctx = c;
        var cur = c.cart.discount_codes || [];
        for (var i = 0; i < cur.length; i++) {
          if (sameCode(cur[i].code, code) && cur[i].applicable) return { done: 'already' };
        }
        var pend = codePending();
        var list = [];
        cur.forEach(function (d) {
          if (d.applicable || pend[d.code.toUpperCase()] || pend[d.code]) list.push(d.code);
        });
        list = list.filter(function (x) {
          return !sameCode(x, code);
        });
        ctx.others = list.slice();
        list.push(code);
        return sfCall(M_CODES, { id: c.id, codes: list }).then(function (d) {
          return { res: d.cartDiscountCodesUpdate };
        });
      })
      .then(function (step) {
        if (step.done === 'already') {
          codeMsg(ct('already'), 'info');
          return null;
        }
        var res = step.res;
        if (!res || !res.cart) throw new Error('no cart');
        var mine = null;
        (res.cart.discountCodes || []).forEach(function (d) {
          if (sameCode(d.code, code)) mine = d;
        });
        if (mine && mine.applicable) {
          codeAdopt(res.cart);
          codeState.value = '';
          codeMsg(ct('ok', { c: code }), 'ok');
          return 'refresh';
        }
        // Warum nicht? Warnungen zu anderen gespeicherten Codes ausblenden
        var warn = null;
        (res.warnings || []).forEach(function (w) {
          if (warn) return;
          var other = ctx.others.some(function (o) {
            return w.message && w.message.toUpperCase().indexOf(String(o).toUpperCase()) !== -1;
          });
          if (!other && CODE_WARN[w.code]) warn = w.code;
        });
        var rule = CODE_WARN[warn] || CODE_WARN.DISCOUNT_NOT_FOUND;
        if (rule[1]) {
          var pend = codePending();
          pend[code] = rule[2];
          codePendingSet(pend);
          codeAdopt(res.cart);
          codeState.value = '';
          codeMsg(ct(rule[0]), 'info');
          return 'refresh';
        }
        // Code wieder aus dem Warenkorb nehmen, dann ggf. als Gutschein versuchen
        return sfCall(M_CODES, { id: ctx.id, codes: ctx.others }).then(function () {
          var gift = raw.replace(/[\s-]+/g, '');
          if ((warn && warn !== 'DISCOUNT_NOT_FOUND') || !/^[A-Za-z0-9]{8,20}$/.test(gift)) {
            codeMsg(ct(rule[0]), 'error');
            return 'refresh';
          }
          var before = {};
          (codeState.gifts || []).forEach(function (g) {
            before[g.id] = 1;
          });
          return sfCall(M_GIFT_ADD, { id: ctx.id, codes: [gift] }).then(function (d) {
            var r = d.cartGiftCardCodesAdd;
            var fresh = null;
            ((r && r.cart && r.cart.appliedGiftCards) || []).forEach(function (g) {
              if (!before[g.id] && gift.toUpperCase().slice(-4) === String(g.lastCharacters).toUpperCase().slice(-4)) fresh = g;
            });
            if (fresh) {
              codeAdopt(r.cart);
              codeState.value = '';
              var amt = giftAmount(fresh, document.querySelector('.ia-sliding-cart'));
              codeMsg(amt ? ct('gift', { a: amt }) : ct('giftOk'), 'ok');
              return 'refresh';
            }
            var off = ((r && r.warnings) || []).some(function (w) {
              return w.code === 'PAYMENTS_GIFT_CARDS_UNAVAILABLE';
            });
            codeMsg(ct(off ? 'giftOff' : 'notFound'), 'error');
            return 'refresh';
          });
        });
      })
      .then(function (after) {
        codeBusy(false);
        if (after === 'refresh') codeRefreshCart();
      })
      .catch(function () {
        codeBusy(false);
        codeMsg(ct('error'), 'error');
      });
  }

  function codeGiftRemove(id) {
    if (codeState.busy) return;
    codeBusy(true);
    cartGid()
      .then(function (c) {
        return sfCall(M_GIFT_RM, { id: c.id, ids: [id] });
      })
      .then(function (d) {
        var r = d.cartGiftCardCodesRemove;
        if (r && r.cart) codeAdopt(r.cart);
        codeBusy(false);
        codeMsg('', '');
        codeRefreshCart();
      })
      .catch(function () {
        codeBusy(false);
        codeMsg(ct('error'), 'error');
      });
  }

  function codeDiscountRemove(code) {
    if (codeState.busy) return;
    codeBusy(true);
    var pend = codePending();
    for (var k in pend) if (sameCode(k, code)) delete pend[k];
    codePendingSet(pend);
    cartGid()
      .then(function (c) {
        var list = (c.cart.discount_codes || [])
          .map(function (d) {
            return d.code;
          })
          .filter(function (x) {
            return !sameCode(x, code);
          });
        return sfCall(M_CODES, { id: c.id, codes: list });
      })
      .then(function (d) {
        var r = d.cartDiscountCodesUpdate;
        if (r && r.cart) codeAdopt(r.cart);
        codeBusy(false);
        codeMsg('', '');
        codeRefreshCart();
      })
      .catch(function () {
        codeBusy(false);
        codeMsg(ct('error'), 'error');
      });
  }

  function codeBuild() {
    var box = document.createElement('div');
    box.className = 'ex-redeem';
    box.setAttribute('data-ex-redeem', '');
    var form = document.createElement('form');
    form.className = 'ex-redeem__form';
    form.setAttribute('novalidate', '');
    var id = 'ex-redeem-input';
    var label = document.createElement('label');
    label.className = 'visually-hidden';
    label.setAttribute('for', id);
    label.textContent = ct('ph');
    var input = document.createElement('input');
    input.id = id;
    input.className = 'ex-redeem__input';
    input.type = 'text';
    input.name = 'ex-redeem';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('enterkeyhint', 'go');
    input.setAttribute('maxlength', '64');
    input.placeholder = ct('ph');
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.className = 'ex-redeem__btn';
    btn.textContent = ct('btn');
    form.appendChild(label);
    form.appendChild(input);
    form.appendChild(btn);
    var chips = document.createElement('div');
    chips.className = 'ex-redeem__chips';
    chips.hidden = true;
    var msg = document.createElement('p');
    msg.className = 'ex-redeem__msg';
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.hidden = true;
    box.appendChild(form);
    box.appendChild(msg);
    box.appendChild(chips);
    input.addEventListener('input', function () {
      codeState.value = input.value;
      if (codeState.tone === 'error') codeMsg('', '');
      else codeRender();
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      codeState.value = input.value;
      codeSubmit();
      try {
        input.blur();
      } catch (e) {}
    });
    return box;
  }

  // Platz: oben im Kassenbereich (leerer Platzhalter von iCart für dessen eigenes Code-Modul)
  function codeBox(root) {
    var parent = root.querySelector('.ia-checkout-layout-parent-container');
    if (!parent) return;
    if (!parent.hasAttribute('data-ex-redeem')) parent.setAttribute('data-ex-redeem', '');
    var box = parent.querySelector('.ex-redeem');
    if (!box) {
      box = codeBuild();
      var slot = parent.firstElementChild;
      if (slot && slot.tagName === 'DIV' && !slot.className && !slot.childNodes.length) slot.appendChild(box);
      else parent.insertBefore(box, parent.firstChild);
      codeRender();
      codeSync(false);
    }
  }

  // ------------------------------------------------------------------
  // 10 · (Runde 28 Style-Vorschaubilder für Swatch King – seit Runde 44 rendert das Theme die
  //      Bilder selbst in passender Größe, snippets/variant-main-picker.liquid)
  // ------------------------------------------------------------------

  // ------------------------------------------------------------------
  // 11 · Runde 28 · Nach oben – erscheint nach zwei Bildschirmhöhen, gläsern
  // ------------------------------------------------------------------
  function backToTop() {
    if (document.querySelector('.ex-top')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ex-top';
    b.setAttribute('aria-label', t({ de: 'Nach oben', en: 'Back to top', pl: 'Do góry', it: 'Torna su' }));
    b.innerHTML =
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 16V4.5M5 9.5l5-5 5 5"/></svg>';
    b.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      b.blur();
    });
    document.body.appendChild(b);
    var ticking = false;
    // Glas passt sich an: über dunklen Flächen (Footer, schwarze Bänder) dunkles Glas mit weißem Pfeil
    function isDarkAt(x, y) {
      // Stapel an dieser Stelle von oben nach unten; erste deckende Hintergrundfarbe entscheidet
      // (Fabric malt Abschnittsflächen als eigene Ebene, daher nicht nur die Vorfahren prüfen)
      // body/html zuletzt: Flächen mit negativem z-index liegen im Stapel hinter body
      var els = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      var page = null;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el === b || b.contains(el)) continue;
        if (el === document.body || el === document.documentElement) {
          page = page || el;
          continue;
        }
        var d = darkBg(el);
        if (d !== null) return d;
      }
      return page ? darkBg(page) === true : false;
    }
    function darkBg(el) {
      var m = (getComputedStyle(el).backgroundColor || '').match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      var c = m[1].split(/[\s,\/]+/).filter(Boolean).map(Number);
      if ((c.length > 3 ? c[3] : 1) < 0.5) return null;
      return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2] < 110;
    }
    // Runde 37 (Ladezeit): Ausblenden über Warenkorb/Menü/Dialogen/Privy und Anheben über die
    // Sticky-Warenkorb-Leiste prüft jetzt dieses Skript (Klassen is-hide / is-lift). Vorher taten
    // das fünf CSS-Regeln „html:has(…) .ex-top“ – die ließen den Browser bei jeder DOM-Änderung
    // die ganze Seite neu berechnen (gemessen: rund 35–40 % der gesamten Stilberechnung).
    var OVERLAY = '.ia-sliding-cart--active, dialog[open], #privy-widget .privy-popup-container, .menu-drawer-container[open]';
    function overlays() {
      var hide = !!document.querySelector(OVERLAY);
      if (hide !== b.classList.contains('is-hide')) b.classList.toggle('is-hide', hide);
      var lift = !!document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
      if (lift !== b.classList.contains('is-lift')) b.classList.toggle('is-lift', lift);
    }
    var poll = null;
    function update() {
      ticking = false;
      var show = window.scrollY > window.innerHeight * 2;
      if (show !== b.classList.contains('is-on')) b.classList.toggle('is-on', show);
      if (show && !poll) poll = setInterval(overlays, 300);
      if (!show && poll) {
        clearInterval(poll);
        poll = null;
      }
      overlays();
      if (!show) return;
      var r = b.getBoundingClientRect();
      var dark = isDarkAt(r.left + r.width / 2, r.top + r.height / 2);
      if (dark !== b.classList.contains('is-dark')) b.classList.toggle('is-dark', dark);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    // Menü, Warenkorb und Filter öffnen per Tipp: sofort nachsehen statt auf den nächsten Takt zu warten
    ['click', 'keyup'].forEach(function (ev) {
      document.addEventListener(
        ev,
        function () {
          if (!b.classList.contains('is-on')) return;
          requestAnimationFrame(overlays);
          setTimeout(overlays, 120);
        },
        { passive: true, capture: true }
      );
    });
    update();
  }

  // ------------------------------------------------------------------
  // 12 · Runde 44 · Größenwahl nativ (snippets/variant-main-picker.liquid) statt Swatch King.
  // variant-picker.js wechselt die Variante selbst (Preis, Kaufbutton, Bilder, ?variant=).
  // Hier nur: merken, dass selbst gewählt wurde (nur dann nimmt der Farbwechsel die Auswahl mit)
  // und die Auswahl in die neue Farbe übernehmen (Abschnitt 17).
  // ------------------------------------------------------------------
  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (!event.isTrusted || !t || !t.closest || !t.closest('variant-picker')) return;
      var details = t.closest('.product-details');
      if (details) details.__exUserTouched = true;
    },
    true
  );

  // Radios der neuen Seite setzen und ein change-Ereignis schicken – variant-picker.js lädt dann
  // die passende Variante wie bei einem Tipp. Werte, die es in der neuen Farbe nicht gibt, bleiben.
  function applyChosen(details, chosen) {
    if (!details || !chosen || !chosen.length) return;
    var sets = details.querySelectorAll('variant-picker fieldset[data-ex-name]');
    var last = null;
    for (var k = 0; k < chosen.length; k++) {
      for (var i = 0; i < sets.length; i++) {
        if (sets[i].getAttribute('data-ex-name') !== chosen[k].name) continue;
        var inputs = sets[i].querySelectorAll('input[type="radio"]');
        for (var j = 0; j < inputs.length; j++) {
          if (inputs[j].value === chosen[k].value && !inputs[j].checked) {
            inputs[j].checked = true;
            last = inputs[j];
          }
        }
      }
    }
    details.__exUserTouched = true;
    if (!last) return;
    // variant-picker.js schreibt ?variant= aus dem angetippten Radio – bei zwei geänderten Optionen
    // (Style + Größe) ist dessen Varianten-ID noch die der alten Kombination. Nach der Antwort
    // (variant:update) die Adresse auf die tatsächlich geladene Variante setzen.
    var tm = 0;
    var fix = function (ev) {
      document.removeEventListener('variant:update', fix);
      clearTimeout(tm);
      var v = ev && ev.detail && ev.detail.resource;
      if (!v || !v.id) return;
      try {
        var url = new URL(location.href);
        if (url.searchParams.get('variant') !== String(v.id)) {
          url.searchParams.set('variant', String(v.id));
          history.replaceState(history.state, '', url.toString());
        }
      } catch (e) {}
    };
    tm = setTimeout(function () {
      document.removeEventListener('variant:update', fix);
    }, 6000);
    document.addEventListener('variant:update', fix);
    last.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ------------------------------------------------------------------

  // ------------------------------------------------------------------
  // 14 · Runde 33: Logo + Streichpreis in Produktfarbe
  // Farbe kommt aus Liquid (blocks/_header-logo.liquid → :root --ex-accent / --ex-accent-text).
  // Hier nur die Wechsel ohne Seitenaufruf: Farb-Option als Variante (Skull Cap, Socken) und
  // Antippen eines Farb-Geschwisters (Farbe wechselt sofort, bevor die nächste Seite lädt).
  // Wert „#logo #text [#kontur]“ oder leer (= Logo schwarz, Streichpreis grau).
  // ------------------------------------------------------------------
  var ACCENT_PLAIN = 'rgb(10 10 10 / 0.5)';
  var accentInitial = null;
  var accentInitialOutline = false;

  function accentLogos() {
    return document.querySelectorAll('.header-logo[data-ex-accent-product]');
  }

  // Runde 41: Wert „#füllung #text [#kontur]“ – text „-“ = Standard-Grau, Kontur optional
  function accentApply(pair) {
    var logos = accentLogos();
    if (!logos.length) return;
    var parts = String(pair || '').trim().split(/\s+/);
    var root = document.documentElement.style;
    var i;
    var hex = function (v) { return !!v && v.charAt(0) === '#'; };
    if (hex(parts[0])) {
      root.setProperty('--ex-accent', parts[0]);
      root.setProperty('--ex-accent-text', hex(parts[1]) ? parts[1] : ACCENT_PLAIN);
      if (hex(parts[2])) root.setProperty('--ex-accent-outline', parts[2]);
      for (i = 0; i < logos.length; i++) {
        // Runde 62: Standardlogo (Schalter „EX · Logo in Produktfarbe“ aus) – nur der Streichpreis wechselt
        if (logos[i].hasAttribute('data-ex-logo-plain')) continue;
        logos[i].classList.add('header-logo--tint');
        logos[i].classList.toggle('header-logo--outline', hex(parts[2]));
      }
    } else {
      root.setProperty('--ex-accent-text', ACCENT_PLAIN);
      for (i = 0; i < logos.length; i++) logos[i].classList.remove('header-logo--tint', 'header-logo--outline');
    }
  }

  function initAccent() {
    var logos = accentLogos();
    if (!logos.length) return;
    accentInitial = logos[0].classList.contains('header-logo--tint');
    accentInitialOutline = logos[0].classList.contains('header-logo--outline');

    document.addEventListener('variant:update', function (event) {
      var logo = document.querySelector('.header-logo[data-ex-accent-opt]');
      if (!logo) return;
      var detail = event.detail || {};
      var data = detail.data || {};
      if (data.productId && String(data.productId) !== logo.getAttribute('data-ex-accent-product')) return;
      var variant = detail.resource;
      if (!variant || !variant.options) return;
      var map;
      try {
        map = JSON.parse(logo.getAttribute('data-ex-accent-map') || '{}');
      } catch (e) {
        return;
      }
      var value = String(variant.options[parseInt(logo.getAttribute('data-ex-accent-opt'), 10)] || '').toUpperCase();
      if (Object.prototype.hasOwnProperty.call(map, value)) accentApply(map[value]);
    });

    document.addEventListener(
      'click',
      function (event) {
        var sw = event.target && event.target.closest ? event.target.closest('.ex-cs__sw[href]') : null;
        if (!sw) return;
        accentApply(sw.getAttribute('data-ex-accent') || '');
      },
      true
    );

    // Zurück-Taste (Seite aus dem Cache): Farbe der Seite wiederherstellen
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var root = document.documentElement.style;
      root.removeProperty('--ex-accent');
      root.removeProperty('--ex-accent-text');
      root.removeProperty('--ex-accent-outline');
      var logos = accentLogos();
      for (var i = 0; i < logos.length; i++) {
        logos[i].classList.toggle('header-logo--tint', !!accentInitial);
        logos[i].classList.toggle('header-logo--outline', !!accentInitialOutline);
      }
    });
  }

  // ------------------------------------------------------------------
  // 15 · Runde 33: Such-Fenster
  //   a) „Zuletzt gesucht“: die letzten 6 Suchbegriffe (nur in diesem Browser, localStorage),
  //      als Chips über „Zuletzt angesehen“; Antippen startet die Suche direkt im Fenster.
  //   b) Bilder im Fenster: beim Öffnen von „lazy“ auf sofort – iOS lud Bilder im geschlossenen
  //      Dialog sonst nicht nach (Bestseller blieben leer).
  //   Platzhalter: snippets/predictive-search-empty-state.liquid · Optik: excentred-master.css 70
  // ------------------------------------------------------------------
  var RS_KEY = 'ex_recent_searches';

  function rsGet() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RS_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (x) {
        return typeof x === 'string' && x.length > 1;
      }).slice(0, 6);
    } catch (e) {
      return [];
    }
  }

  function rsSet(list) {
    try {
      window.localStorage.setItem(RS_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) {}
  }

  function rsAdd(term) {
    term = String(term || '').replace(/\s+/g, ' ').trim();
    if (term.length < 2 || term.length > 60) return;
    var lower = term.toLowerCase();
    var list = rsGet().filter(function (x) {
      return x.toLowerCase() !== lower;
    });
    list.unshift(term);
    rsSet(list);
  }

  var RS_TEXT = {
    title: { de: 'Zuletzt gesucht', pl: 'Ostatnio wyszukiwane', it: 'Ricerche recenti', en: 'Recent searches' },
    clear: { de: 'Löschen', pl: 'Wyczyść', it: 'Cancella', en: 'Clear' }
  };
  var RS_ICON =
    '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><circle cx="6" cy="6" r="4.6"/><path d="M6 3.4V6l1.8 1.2"/></svg>';

  function rsEsc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function rsRender() {
    var boxes = document.querySelectorAll('[data-ex-recent-searches]');
    if (!boxes.length) return;
    var list = rsGet();
    var sig = list.join('\u0001');
    for (var b = 0; b < boxes.length; b++) {
      var box = boxes[b];
      if (box.getAttribute('data-sig') === sig && (sig === '' || box.firstElementChild)) continue;
      box.setAttribute('data-sig', sig);
      if (!list.length) {
        box.innerHTML = '';
        box.hidden = true;
        continue;
      }
      var html =
        '<h4 class="predictive-search-results__title">' +
        rsEsc(t(RS_TEXT.title)) +
        '<button type="button" class="ex-sr-recent__clear" data-ex-recent-clear>' +
        rsEsc(t(RS_TEXT.clear)) +
        '</button></h4><ul class="ex-sr-links__list" role="list">';
      for (var i = 0; i < list.length; i++) {
        html +=
          '<li><button type="button" class="ex-sr-chip" data-ex-recent-term="' +
          rsEsc(list[i]) +
          '">' +
          RS_ICON +
          '<span>' +
          rsEsc(list[i]) +
          '</span></button></li>';
      }
      box.innerHTML = html + '</ul>';
      box.hidden = false;
    }
  }

  function searchInputOf(el) {
    var comp = el.closest ? el.closest('predictive-search-component') : null;
    return comp ? comp.querySelector('input[type="search"], .search-input') : null;
  }

  function eagerSearchImages(scope) {
    var imgs = scope.querySelectorAll('.ex-sc__pic[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
  }

  function initSearch() {
    var comps = document.querySelectorAll('predictive-search-component:not([data-ex-search])');
    for (var c = 0; c < comps.length; c++) {
      (function (comp) {
        comp.setAttribute('data-ex-search', '');
        var dialog = comp.closest('dialog');
        var isOpen = function () {
          return !dialog || dialog.open;
        };
        // Morph des Themes leert den Platzhalter → sofort (vor dem Zeichnen) neu füllen
        new MutationObserver(function () {
          rsRender();
          if (isOpen()) eagerSearchImages(comp);
        }).observe(comp, { childList: true, subtree: true });
        if (dialog) {
          new MutationObserver(function () {
            if (dialog.open) {
              rsRender();
              eagerSearchImages(comp);
            }
          }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
        }
        comp.addEventListener('submit', function (event) {
          var input = searchInputOf(event.target);
          if (input) rsAdd(input.value);
        });
        comp.addEventListener('click', function (event) {
          var target = event.target;
          if (!target || !target.closest) return;
          var clear = target.closest('[data-ex-recent-clear]');
          if (clear) {
            event.preventDefault();
            rsSet([]);
            rsRender();
            return;
          }
          var chip = target.closest('[data-ex-recent-term]');
          if (chip) {
            event.preventDefault();
            var input = searchInputOf(chip);
            if (!input) return;
            var term = chip.getAttribute('data-ex-recent-term');
            input.value = term;
            input.focus();
            try {
              input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }));
            } catch (e) {
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
            return;
          }
          // Treffer, Vorschlag oder „Alle anzeigen“ nach einer Eingabe → Begriff merken
          if (target.closest('.predictive-search-results__inner a[href], .predictive-search__search-button')) {
            var inp = searchInputOf(target);
            if (inp && inp.value.trim().length > 1) rsAdd(inp.value);
          }
        });
      })(comps[c]);
    }
    rsRender();
  }


  // ------------------------------------------------------------------
  // 16 · Runde 34: Farbfelder (blocks/ex-color-siblings.liquid)
  //   Über den Feldern steht nur die Farbe. Maus über ein Feld → Name dieser Farbe (Vorschau),
  //   Maus weg → wieder die aktuelle. Antippen → Unterstrich und Name springen sofort auf die neue
  //   Farbe, während die Seite der Farbe lädt. Optik: excentred-master.css 71.
  // ------------------------------------------------------------------
  function initColourLabel() {
    var blocks = document.querySelectorAll('.ex-cs:not([data-ex-cs-ready])');
    for (var i = 0; i < blocks.length; i++) {
      (function (block) {
        block.setAttribute('data-ex-cs-ready', '');
        var val = block.querySelector('[data-ex-cs-val]');
        if (!val) return;
        var fallback = val.getAttribute('data-ex-cs-default') || val.textContent;
        var show = function (name) {
          val.textContent = name || fallback;
        };
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          block.addEventListener('mouseover', function (event) {
            var sw = event.target.closest ? event.target.closest('.ex-cs__sw[data-ex-name]') : null;
            if (sw) show(sw.getAttribute('data-ex-name'));
          });
          block.addEventListener('mouseleave', function () {
            show('');
          });
        }
        block.addEventListener('click', function (event) {
          var sw = event.target.closest ? event.target.closest('a.ex-cs__sw') : null;
          if (!sw || event.metaKey || event.ctrlKey || event.shiftKey) return;
          var cur = block.querySelector('.ex-cs__sw.is-current');
          if (cur && cur !== sw) cur.classList.remove('is-current');
          sw.classList.add('is-current');
          fallback = sw.getAttribute('data-ex-name') || fallback;
          show('');
        });
        // Zurück-Taste: Seite kommt aus dem Cache → Ausgangszustand
        window.addEventListener('pageshow', function (event) {
          if (!event.persisted) return;
          var items = block.querySelectorAll('.ex-cs__sw');
          for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-current', items[k].tagName === 'SPAN');
          fallback = val.getAttribute('data-ex-cs-default') || fallback;
          show('');
        });
      })(blocks[i]);
    }
  }


  // ------------------------------------------------------------------
  // 17 · Runde 41: Farbwechsel ohne Neuladen (Farb-Geschwister, blocks/ex-color-siblings.liquid)
  //   Antippen eines Farbfelds lädt die Seite der Farbe im Hintergrund und tauscht nur den Inhalt
  //   (<main>) aus – Kopf, Warenkorb, Skripte und Styles bleiben stehen: kein Ladebalken, kein
  //   weißes Aufblitzen, die Scroll-Position bleibt. Die Adresse wechselt mit, Zurück/Vor funktioniert.
  //   Vorab-Laden beim Berühren (Handy) bzw. Überfahren (Maus) → meist ist die Seite schon da.
  //   Eine bereits gewählte Größe wird in die neue Farbe übernommen.
  //   App-Daten außerhalb von <main> ziehen mit: ShopifyAnalytics.meta, Swym (Produkt-Kontext +
  //   Merken-Button), GenLook (genlook-page-context). (Swatch King bis Runde 43.)
  //   Klappt etwas nicht (Netz, unerwartete Antwort), normaler Seitenaufruf – nie ein halber Zustand.
  //   Im Theme-Editor und mit Strg/⌘/Umschalt/Mittelklick bleibt es beim normalen Link.
  // ------------------------------------------------------------------
  var CS_CACHE = {};
  var CS_ORDER = [];
  var csToken = 0;
  var csPath = location.pathname;
  var csSwitched = false;

  function csKey(href) {
    try {
      var u = new URL(href, location.href);
      return u.origin === location.origin && /\/products\//.test(u.pathname) ? u.pathname : '';
    } catch (e) {
      return '';
    }
  }

  // Anfrage: Pfad, bei Zurück/Vor auch die gemerkte Variante (?variant=) – so stimmt die Größe wieder
  function csReq(href, withVariant) {
    var path = csKey(href);
    if (!path || !withVariant) return path;
    try {
      var v = new URL(href, location.href).searchParams.get('variant');
      return v && /^\d+$/.test(v) ? path + '?variant=' + v : path;
    } catch (e) {
      return path;
    }
  }

  function csFetch(path) {
    if (CS_CACHE[path]) return CS_CACHE[path];
    var p = fetch(path, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text().then(function (html) {
        return { html: html, url: r.url || path };
      });
    });
    p.catch(function () {
      if (CS_CACHE[path] === p) delete CS_CACHE[path];
    });
    CS_CACHE[path] = p;
    CS_ORDER.push(path);
    if (CS_ORDER.length > 12) delete CS_CACHE[CS_ORDER.shift()];
    return p;
  }

  // Runde 42: Seite nur einmal zerlegen (Vorladen + Antippen nutzen dasselbe Dokument)
  function csDoc(res) {
    if (!res.doc) res.doc = new DOMParser().parseFromString(res.html, 'text/html');
    return res.doc;
  }

  // Runde 42: erstes Galeriebild (Desktop: die ersten zwei) der vorgeladenen Farbe schon in den
  // Browser-Speicher holen – nach dem Tausch steht das Bild sofort da statt nachzuladen.
  function csWarm(res) {
    if (!res || res.warm) return;
    res.warm = [];
    try {
      var imgs = csDoc(res).querySelectorAll('main media-gallery img');
      var n = Math.min(imgs.length, window.innerWidth >= 750 ? 2 : 1);
      for (var i = 0; i < n; i++) {
        var pre = new Image();
        pre.decoding = 'async';
        var sz = imgs[i].getAttribute('sizes');
        var ss = imgs[i].getAttribute('srcset');
        if (sz) pre.sizes = sz;
        if (ss) pre.srcset = ss;
        pre.src = imgs[i].getAttribute('src') || '';
        res.warm.push(pre);
      }
    } catch (e) {}
  }

  // Runde 42: Nach dem Laden der Seite im Leerlauf die Nachbarfarben vorladen (Handy 4, Desktop 6),
  // nacheinander und nie bei „Datensparen“ oder langsamer Verbindung. Antippen wirkt dann sofort.
  var csIdleTimer = 0;
  function csIdle(delay) {
    clearTimeout(csIdleTimer);
    csIdleTimer = setTimeout(function () {
      var c = navigator.connection;
      if (c && (c.saveData || /2g|3g/.test(c.effectiveType || ''))) return;
      var links = document.querySelectorAll('main a.ex-cs__sw[href]');
      var max = window.innerWidth >= 750 ? 6 : 4;
      var list = [];
      for (var i = 0; i < links.length && list.length < max; i++) {
        var k = csReq(links[i].href, false);
        if (k && k !== csPath && list.indexOf(k) < 0) list.push(k);
      }
      var ric =
        window.requestIdleCallback ||
        function (fn) {
          return setTimeout(fn, 250);
        };
      var at = 0;
      var mine = csToken;
      (function next() {
        if (at >= list.length || mine !== csToken) return;
        var k = list[at++];
        ric(
          function () {
            csFetch(k).then(
              function (res) {
                csWarm(res);
                setTimeout(next, 120);
              },
              function () {
                setTimeout(next, 120);
              }
            );
          },
          { timeout: 2500 }
        );
      })();
    }, delay);
  }

  function csRun(code) {
    var s = document.createElement('script');
    s.textContent = code;
    document.head.appendChild(s);
    s.remove();
  }

  // Gewählte Optionen (nur wenn selbst angetippt): [{ name: 'SIZE', value: 'L' }, …]
  function csChosen() {
    var details = document.querySelector('main .product-details');
    if (!details || !details.__exUserTouched) return [];
    var out = [];
    var sets = details.querySelectorAll('variant-picker fieldset[data-ex-name]');
    for (var i = 0; i < sets.length; i++) {
      var c = sets[i].querySelector('input:checked');
      if (c) out.push({ name: sets[i].getAttribute('data-ex-name'), value: c.value });
    }
    return out;
  }

  function csSyncHead(doc) {
    if (doc.title) document.title = doc.title;
    var sel = [
      'meta[name="description"]',
      'link[rel="canonical"]',
      'meta[property="og:title"]',
      'meta[property="og:url"]',
      'meta[property="og:description"]',
      'meta[property="og:image"]',
      'meta[property="og:image:secure_url"]',
      'meta[property="og:price:amount"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]'
    ];
    for (var i = 0; i < sel.length; i++) {
      var a = document.head.querySelector(sel[i]);
      var b = doc.head && doc.head.querySelector(sel[i]);
      if (!a || !b) continue;
      if (b.hasAttribute('content')) a.setAttribute('content', b.getAttribute('content'));
      if (b.hasAttribute('href')) a.setAttribute('href', b.getAttribute('href'));
    }
    var olds = document.head.querySelectorAll('link[rel="alternate"][hreflang]');
    var news = doc.head ? doc.head.querySelectorAll('link[rel="alternate"][hreflang]') : [];
    if (olds.length && news.length === olds.length) {
      for (var j = 0; j < olds.length; j++) olds[j].setAttribute('href', news[j].getAttribute('href'));
    }
  }

  function csSyncData(doc) {
    var i;
    // Daten-Inseln mit id außerhalb von <main> (JSON der Apps, Swym-Snippet …): nur Inhalt ersetzen
    var islands = doc.querySelectorAll('script[id]:not([src])');
    for (i = 0; i < islands.length; i++) {
      if (islands[i].closest('main')) continue;
      var cur = document.getElementById(islands[i].id);
      if (cur && cur.tagName === 'SCRIPT' && !cur.closest('main') && cur.textContent !== islands[i].textContent) {
        cur.textContent = islands[i].textContent;
      }
    }
    var scripts = doc.querySelectorAll('script:not([src]):not([id])');
    for (i = 0; i < scripts.length; i++) {
      if (scripts[i].closest('main')) continue;
      var t = scripts[i].textContent;
      // Shopify: Produkt/Seite für Apps und Tracking-Hilfen
      var m0 = t.indexOf('var meta = {');
      if (m0 > -1 && t.indexOf('window.ShopifyAnalytics.meta') > -1) {
        var m1 = t.indexOf('for (var attr in meta)', m0);
        if (m1 > -1) {
          try {
            var meta = JSON.parse(t.slice(m0 + 11, m1).trim().replace(/;$/, ''));
            window.ShopifyAnalytics = window.ShopifyAnalytics || {};
            window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
            for (var key in meta) window.ShopifyAnalytics.meta[key] = meta[key];
          } catch (e) {}
        }
      }
    }
  }

  // Kopf: Logo-Farbe/Kontur + Daten der neuen Seite übernehmen (Abschnitt 14)
  function csHeader(doc) {
    var nl = doc.querySelector('.header-logo');
    var logos = accentLogos();
    if (!nl || !logos.length) return;
    var st = null;
    var styles = doc.querySelectorAll('style');
    for (var i = 0; i < styles.length; i++) {
      if (styles[i].textContent.indexOf('--ex-accent:') > -1) st = styles[i];
    }
    var cur = null;
    var mine = document.querySelectorAll('style');
    for (i = 0; i < mine.length; i++) {
      if (mine[i].textContent.indexOf('--ex-accent:') > -1) cur = mine[i];
    }
    if (cur && st) cur.textContent = st.textContent;
    else if (cur && !st) cur.textContent = '';
    else if (!cur && st) document.head.appendChild(st.cloneNode(true));
    // Runde 51: auch Logo-Art (data-ex-logo), Maske und Maße (--ex-logo-mask / --ex-alt-* im style) übernehmen
    var attrs = ['data-ex-accent-product', 'data-ex-accent-opt', 'data-ex-accent-map', 'data-ex-logo', 'style'];
    for (i = 0; i < logos.length; i++) {
      for (var k = 0; k < attrs.length; k++) {
        if (nl.hasAttribute(attrs[k])) logos[i].setAttribute(attrs[k], nl.getAttribute(attrs[k]));
        else logos[i].removeAttribute(attrs[k]);
      }
      logos[i].classList.toggle('header-logo--tint', nl.classList.contains('header-logo--tint'));
      logos[i].classList.toggle('header-logo--outline', nl.classList.contains('header-logo--outline'));
      logos[i].classList.toggle('header-logo--alt', nl.classList.contains('header-logo--alt'));
    }
    var root = document.documentElement.style;
    root.removeProperty('--ex-accent');
    root.removeProperty('--ex-accent-text');
    root.removeProperty('--ex-accent-outline');
    accentInitial = nl.classList.contains('header-logo--tint');
    accentInitialOutline = nl.classList.contains('header-logo--outline');
  }

  // Apps, die sich beim Seitenstart einmal einrichten
  function csApps() {
    // Swym: Produkt-Kontext der neuen Seite + Merken-Button auf der Produktseite
    try {
      var snip = document.getElementById('swym-snippet');
      var swat = window._swat;
      if (snip && swat) {
        var prevent = window._SwymPreventAutoLoad;
        window._SwymPreventAutoLoad = true;
        csRun(snip.textContent);
        window._SwymPreventAutoLoad = prevent;
        if (typeof window.swymPageLoad === 'function') window.swymPageLoad();
        if (window.SwymPageData) {
          if (typeof swat.trackPageview === 'function') swat.trackPageview(window.SwymPageData);
          else if (typeof swat.setCurrentPageData === 'function') swat.setCurrentPageData(window.SwymPageData);
        }
      }
    } catch (e) {}
  }

  function csApply(doc, url, push, chosen, fromKeyboard, wasSlow) {
    var main = document.querySelector('main');
    var fresh = doc.querySelector('main');
    if (!main || !fresh || !fresh.querySelector('.product-details')) return false;
    var node = document.importNode(fresh, true);
    // Skripte aus dem DOMParser laufen nicht von selbst → neu anlegen (JSON-Daten bleiben, wie sie sind)
    var list = node.querySelectorAll('script');
    for (var i = 0; i < list.length; i++) {
      var old = list[i];
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'module' && type !== 'text/javascript' && type !== 'application/javascript') continue;
      var s = document.createElement('script');
      for (var j = 0; j < old.attributes.length; j++) s.setAttribute(old.attributes[j].name, old.attributes[j].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    }
    // Swym hängt seinen (bei uns ausgeblendeten) Merken-Button beim Start einmal in den Kaufbereich
    // und greift später per id darauf zu → dieselben Knoten in den neuen Kaufbereich umziehen.
    var oldAtc = main.querySelector('.product-details add-to-cart-component');
    var newAtc = node.querySelector('.product-details add-to-cart-component');
    if (oldAtc && newAtc) {
      var keep = oldAtc.querySelectorAll(':scope > .swym-button-bar, :scope > #swym-atw-button-container');
      for (var q = 0; q < keep.length; q++) newAtc.appendChild(keep[q]);
    }
    csSyncHead(doc);
    csSyncData(doc);
    if (push) history.pushState({ exCs: 1 }, '', url);
    csPath = location.pathname;
    csSwitched = true;
    var y = window.scrollY;
    // Runde 42: Weiches Aufblenden nur, wenn die Galerie vorher sichtbar zurückgenommen war (Laden > 160 ms).
    // War die Farbe vorgeladen, erscheint sie ohne Verzögerung.
    if (wasSlow) node.classList.add('ex-cs-enter');
    main.replaceWith(node);
    if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
    if (wasSlow) {
      setTimeout(function () {
        node.classList.remove('ex-cs-enter');
      }, 300);
    }
    csHeader(doc);
    var details = node.querySelector('.product-details');
    initColourLabel();
    scan();
    // Runde 44: gewählte Größe/Style in die neue Farbe übernehmen (nach dem Einhängen der Elemente)
    if (chosen && chosen.length) {
      setTimeout(function () {
        applyChosen(details, chosen);
      }, 0);
    }
    csApps();
    if (fromKeyboard) {
      var h = node.querySelector('.product-details h1');
      if (h) {
        h.setAttribute('tabindex', '-1');
        h.focus({ preventScroll: true });
      }
    }
    // Runde 42: Ereignis mit Produktdaten – ein Custom Pixel (Kundenereignisse) kann daraus
    // ViewContent/view_item für Meta, TikTok und Google machen (Vorlage in der Projekt-Doku, Runde 42).
    var detail = { url: url };
    try {
      var pm = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var idIn = node.querySelector('.product-details form[action*="/cart/add"] input[name="id"]');
      var vid = idIn ? parseInt(idIn.value, 10) : NaN;
      if (pm) {
        var vv = null;
        for (var w = 0; pm.variants && w < pm.variants.length; w++) {
          if (pm.variants[w].id === vid) vv = pm.variants[w];
        }
        if (!vv && pm.variants && pm.variants.length) vv = pm.variants[0];
        detail.productId = pm.id;
        detail.productType = pm.type || '';
        detail.vendor = pm.vendor || '';
        if (vv) {
          detail.variantId = vv.id;
          detail.sku = vv.sku || '';
          detail.title = vv.name || '';
          detail.price = typeof vv.price === 'number' ? vv.price / 100 : null;
        }
        detail.currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('ex_colour_switch', detail);
      }
    } catch (e) {}
    // Runde 43: Produktansicht der neuen Farbe direkt an die bereits geladenen App-Pixel
    // (Meta-App: fbq, Google-App: gtag) – kein zusätzliches Skript, Einwilligung gilt wie bei den Apps.
    // Formate wie Katalog/Feed: Meta = Varianten-ID, Google = shopify_DE_<Produkt>_<Variante>.
    // TikTok läuft über das Custom Pixel „EX Farbwechsel-Tracking“ (Ereignis ex_colour_switch).
    try {
      if (detail.productId && detail.variantId) {
        var exVal = typeof detail.price === 'number' ? detail.price : 0;
        var exCur = detail.currency || 'EUR';
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'ViewContent', {
            content_ids: [String(detail.variantId)],
            content_type: 'product',
            content_name: detail.title || '',
            content_category: detail.productType || '',
            value: exVal,
            currency: exCur
          });
        }
        if (typeof window.gtag === 'function') {
          var exId = 'shopify_DE_' + detail.productId + '_' + detail.variantId;
          window.gtag('event', 'view_item', {
            currency: exCur,
            value: exVal,
            items: [{
              id: exId,
              item_id: exId,
              item_name: detail.title || '',
              item_brand: 'EXCENTRED®',
              item_category: detail.productType || '',
              item_variant: detail.sku || '',
              price: exVal,
              google_business_vertical: 'retail'
            }]
          });
        }
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('ex:colour-switch', { detail: detail }));
    csIdle(900);
    return true;
  }

  function csGo(href, push, fromKeyboard) {
    var path = csReq(href, !push);
    if (!path) {
      location.assign(href);
      return;
    }
    var token = ++csToken;
    var chosen = push ? csChosen() : [];
    var html = document.documentElement;
    var wasSlow = false;
    var slow = setTimeout(function () {
      wasSlow = true;
      html.classList.add('ex-cs-loading');
    }, 160);
    var done = function () {
      clearTimeout(slow);
      html.classList.remove('ex-cs-loading');
    };
    csFetch(path).then(
      function (res) {
        if (token !== csToken) return;
        done();
        var ok = false;
        try {
          var doc = csDoc(res);
          ok = csApply(doc, push ? (res.url && csKey(res.url) ? res.url.split('#')[0] : path) : location.href, push, chosen, fromKeyboard, wasSlow);
        } catch (e) {
          ok = false;
        }
        if (!ok) location.assign(href);
      },
      function () {
        if (token !== csToken) return;
        done();
        location.assign(href);
      }
    );
  }

  function initColourSwitch() {
    if (!window.fetch || !window.DOMParser || !window.history || !history.pushState) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!document.querySelector('main .product-details')) return;
    var prefetch = function (event) {
      var a = event.target && event.target.closest ? event.target.closest('main a.ex-cs__sw[href]') : null;
      if (!a) return;
      var k = csReq(a.href, false);
      if (k && k !== csPath) csFetch(k).then(csWarm, function () {});
    };
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
    document.addEventListener('focusin', prefetch);
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest ? event.target.closest('main a.ex-cs__sw[href]') : null;
      if (!a) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (a.target && a.target !== '_self') return;
      if (!csKey(a.href)) return;
      event.preventDefault();
      csGo(a.href, true, event.detail === 0);
    });
    window.addEventListener('popstate', function () {
      if (!csSwitched || location.pathname === csPath) return;
      if (!csKey(location.href)) {
        location.reload();
        return;
      }
      csGo(location.href, false, false);
    });
    // Runde 42: Nachbarfarben im Leerlauf vorladen – erst wenn die Seite selbst fertig ist
    if (document.readyState === 'complete') csIdle(1200);
    else
      window.addEventListener(
        'load',
        function () {
          csIdle(1200);
        },
        { once: true }
      );
  }

  // ------------------------------------------------------------------
  // Runde 37 (Ladezeit): Klasse ex-bis-on am Kaufbereich, solange der Benachrichtigen-Knopf
  // (x-back-in-stock) sichtbar ist. Ersetzt die CSS-Regel :has(> .x-bis-btn[style*='flex']) –
  // der Style-Teilstring in :has() machte jede Inline-Style-Änderung der Seite zum Prüfanlass.
  // ------------------------------------------------------------------
  function bisWatch() {
    var list = document.querySelectorAll('.product-details add-to-cart-component:not([data-ex-bis])');
    for (var i = 0; i < list.length; i++) {
      (function (atc) {
        atc.setAttribute('data-ex-bis', '');
        function sync() {
          var b = null;
          for (var k = 0; k < atc.children.length; k++) {
            if (atc.children[k].classList.contains('x-bis-btn')) b = atc.children[k];
          }
          var on = !!(b && b.style.display === 'flex');
          if (on !== atc.classList.contains('ex-bis-on')) atc.classList.toggle('ex-bis-on', on);
        }
        new MutationObserver(sync).observe(atc, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'disabled'] });
        sync();
      })(list[i]);
    }
  }

  // ------------------------------------------------------------------
  // Runde 39: Złoty-Betrag für die Gratis-Versand-Grenze (Polen).
  // ex-policy-copy setzt bei PLN <span class="ex-fx" data-ex-fx-eur="75">75 €</span>.
  // Umrechnung mit dem Shopify-Kurs, aufgerundet auf volle 10 zł – so ist der angezeigte
  // Betrag nie kleiner als die echte Grenze im Warenkorb.
  // ------------------------------------------------------------------
  function fxAmounts() {
    var els = document.querySelectorAll('.ex-fx[data-ex-fx-eur]:not([data-ex-fx-done])');
    if (!els.length) return;
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur && cur.active === 'PLN' ? parseFloat(cur.rate) : NaN;
    if (!(rate > 0)) return;
    for (var i = 0; i < els.length; i++) {
      var eur = parseFloat(els[i].getAttribute('data-ex-fx-eur'));
      if (!(eur > 0)) continue;
      var pln = Math.ceil((eur * rate) / 10) * 10;
      els[i].textContent = pln + '\u00a0zł';
      els[i].setAttribute('data-ex-fx-done', '');
    }
  }

  function scan() {
    var i;
    fxAmounts();
    bisWatch();
    var ends = document.querySelectorAll('[data-ex-gridend]:not([data-ready])');
    for (i = 0; i < ends.length; i++) initGridEnd(ends[i]);
    var texts = document.querySelectorAll('[data-ex-ctext]:not([data-ready])');
    for (i = 0; i < texts.length; i++) initText(texts[i]);
    decorateCart();
    cartTweaks();
    syncCount();
    notifyContext();
    initSearch();
    keepUnits();
    yzRender();
  }

  // ------------------------------------------------------------------
  // 18 · Runde 45: In den Produkt-Reitern (Beschreibung, Pflege, Versand) brach der Umbruch
  // zwischen Zahl und Einheit („100 / % Baumwolle“). Das Leerzeichen davor wird zu einem
  // geschützten Leerzeichen. Läuft nur über die (kleinen) Reiter-Inhalte, jeder Knoten einmal.
  // ------------------------------------------------------------------
  var UNIT_RE = /(\d) (%|°C|°F|°|g\/m²|g\/m2|gsm|GSM|cm|mm|kg|g|€|zł|PLN)(?=[\s.,;:)!?]|$)/g;
  function keepUnits() {
    var boxes = document.querySelectorAll('.product-details .accordion .details-content:not([data-ex-units])');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      box.setAttribute('data-ex-units', '1');
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var v = node.nodeValue;
        if (v.indexOf(' ') < 0) continue;
        var nv = v.replace(UNIT_RE, '$1\u00A0$2');
        if (nv !== v) node.nodeValue = nv;
      }
    }
  }

  // ------------------------------------------------------------------
  // 13 · Runde 30: Merkliste-Icon im Header kommt jetzt aus dem Theme (header-actions).
  // Die Swym-App liefert am Seitenende zusätzlich ein eigenes Icon mit derselben ID –
  // das entfernen wir, damit die ID eindeutig bleibt (CSS blendet es ohnehin aus).
  // ------------------------------------------------------------------
  function dropDuplicateWishIcon() {
    var extra = document.querySelectorAll('a#swym-advanced-header-icon:not(.ex-wish-head)');
    if (!document.querySelector('a#swym-advanced-header-icon.ex-wish-head')) return;
    for (var i = 0; i < extra.length; i++) extra[i].remove();
  }

  // ------------------------------------------------------------------
  // Runde 44 (Ladezeit): Häkchen-Grafik der Schnellkauf-Buttons auf Produktkarten
  // (snippets/add-to-cart-button.liquid, lazy_burst) erst beim Antippen einsetzen – gleiche
  // Grafik wie assets/icon-checkmark-burst.svg, die Animation (base.css) läuft wie vorher.
  // ------------------------------------------------------------------
  function burstSvg() {
    var lines = '';
    for (var i = 0; i < 8; i++) {
      lines += '<g style="--index: ' + i + ';"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"/></g>';
    }
    return (
      '<svg aria-hidden="true" class="checkmark-burst" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<g class="check"><circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>' +
      '<g class="burst">' + lines + '</g></svg>'
    );
  }

  function fillBurst(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.add-to-cart-button');
    if (!btn) return;
    var slot = btn.querySelector('[data-ex-burst]');
    if (slot && !slot.firstChild) slot.innerHTML = burstSvg();
  }

  ['pointerdown', 'click', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, fillBurst, true);
  });

  // ------------------------------------------------------------------
  // 19 · Runde 52: Größenberater im Size Guide (blocks/ex-fit-guide.liquid, CSS Abschnitt 75)
  // Grundlage Kevins Tabelle: bis 159 XXS · 160–164 XS · 165–173 S · 174–182 M · 183–189 L · ab 190 XL.
  // Daraus ein stufenloser Wert (Mitte einer Spanne = volle Größe), dann:
  //  · Gewicht: im Normalbereich (BMI 20,5–24, Damen-Artikel 19,5–23) keine Änderung; darüber je 12 kg
  //    eine Größe größer, darunter je 25 kg eine kleiner (schlanke Menschen tragen Boxy trotzdem gern normal).
  //  · Passform des Teils (Fit-Skala 1–5): fällt klein aus +1 / etwas klein +0,4 / sehr weit −0,4.
  // Gerundet; liegt der Wert nah an der Grenze, nennt der Hinweis beide Größen. Nur Größen, die es gibt.
  // Eingaben bleiben für die Sitzung gespeichert (sessionStorage, nur im Browser).
  // ------------------------------------------------------------------
  var REC_IDX = { XXS: -1, XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5, '2XL': 5, XXXL: 6, '3XL': 6, '4XL': 7 };
  var REC_BANDS = [159.5, 164.5, 173.5, 182.5, 189.5];

  function recNum(v) {
    var n = parseFloat(String(v || '').replace(',', '.').replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : NaN;
  }

  function recHeightScore(h) {
    if (h < REC_BANDS[0]) return -0.5 - (REC_BANDS[0] - h) / 7;
    if (h >= REC_BANDS[4]) return 3.5 + (h - REC_BANDS[4]) / 7;
    for (var i = 0; i < 4; i++) {
      if (h < REC_BANDS[i + 1]) return i - 0.5 + (h - REC_BANDS[i]) / (REC_BANDS[i + 1] - REC_BANDS[i]);
    }
    return 3;
  }

  function recScore(h, w, g, fit) {
    var m2 = (h / 100) * (h / 100);
    var lo = (g === 'w' ? 19.5 : 20.5) * m2;
    var hi = (g === 'w' ? 23 : 24) * m2;
    var adj = w > hi ? (w - hi) / 12 : w < lo ? (w - lo) / 25 : 0;
    adj = Math.max(-0.8, Math.min(2, adj));
    var fitAdj = { 1: 1, 2: 0.4, 3: 0, 4: 0, 5: -0.4 }[fit] || 0;
    return recHeightScore(h) + adj + fitAdj;
  }

  // Größenliste eines Teils → [{v: Wert, i: Stufe}] sortiert; unbekannte Werte (z. B. „One Size“) → null
  function recSizes(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var k = String(list[i]).toUpperCase().replace(/\s+/g, '');
      if (!Object.prototype.hasOwnProperty.call(REC_IDX, k)) return null;
      out.push({ v: list[i], i: REC_IDX[k] });
    }
    out.sort(function (a, b) { return a.i - b.i; });
    return out.length ? out : null;
  }

  function recPick(sizes, score) {
    var want = Math.floor(score + 0.5);
    var best = sizes[0];
    for (var i = 0; i < sizes.length; i++) {
      if (Math.abs(sizes[i].i - want) < Math.abs(best.i - want) || (Math.abs(sizes[i].i - want) === Math.abs(best.i - want) && sizes[i].i > best.i)) best = sizes[i];
    }
    var edge = '';
    if (want > sizes[sizes.length - 1].i) edge = 'max';
    else if (want < sizes[0].i) edge = 'min';
    // nah an der Grenze? → Nachbargröße nennen (a = kleinere, b = größere)
    var between = null;
    if (!edge) {
      var frac = score - best.i;
      var nb = null;
      if (frac > 0.3) nb = best.i + 1;
      else if (frac < -0.3) nb = best.i - 1;
      if (nb !== null) {
        for (var j = 0; j < sizes.length; j++) {
          if (sizes[j].i === nb) between = nb > best.i ? [best.v, sizes[j].v] : [sizes[j].v, best.v];
        }
      }
    }
    return { size: best.v, edge: edge, between: between };
  }

  function recEsc(v) {
    return String(v).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function recFieldset(root, name) {
    var scope = root.closest('.product-details') || document;
    var sets = scope.querySelectorAll('variant-picker fieldset[data-ex-name]');
    for (var i = 0; i < sets.length; i++) {
      if (sets[i].getAttribute('data-ex-name') === name) return sets[i];
    }
    return null;
  }

  function recRadio(root, name, value) {
    var set = recFieldset(root, name);
    if (!set) return null;
    var inputs = set.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].value === value) return inputs[i];
    return null;
  }

  function recUpdate(root) {
    var data, t;
    try {
      data = JSON.parse(root.getAttribute('data-ex-rec') || '{}');
      t = JSON.parse(root.getAttribute('data-ex-rec-t') || '{}');
    } catch (e) {
      return;
    }
    var out = root.querySelector('[data-ex-rec-out]');
    var hIn = root.querySelector('[data-ex-rec-h]');
    var wIn = root.querySelector('[data-ex-rec-w]');
    if (!out || !hIn || !wIn) return;
    var h = recNum(hIn.value);
    var w = recNum(wIn.value);
    if (h > 0 && h < 3) h = h * 100; // „1,80“ → 180 cm
    root.__exRec = null;
    if (!hIn.value.trim() || !wIn.value.trim()) {
      out.innerHTML = '<p class="ex-rec__hint">' + recEsc(t.empty || '') + '</p>';
      // Runde 53: beide Felder leer = Werte vergessen (die Zeile „FÜR DICH“ verschwindet)
      if (!hIn.value.trim() && !wIn.value.trim()) {
        try { sessionStorage.removeItem('ex_rec'); } catch (e) {}
        yzRender();
      }
      return;
    }
    if (!(h >= 140 && h <= 215 && w >= 35 && w <= 180)) {
      out.innerHTML = '<p class="ex-rec__hint">' + recEsc(t.invalid || '') + '</p>';
      return;
    }
    try { sessionStorage.setItem('ex_rec', JSON.stringify({ h: hIn.value.trim(), w: wIn.value.trim() })); } catch (e) {}
    yzRender();
    var parts = data.p || [];
    var res = [];
    var notes = [];
    for (var i = 0; i < parts.length; i++) {
      var sizes = recSizes(parts[i].v || []);
      if (!sizes) continue;
      var pick = recPick(sizes, recScore(h, w, data.g, parts[i].f || 3));
      res.push({ n: parts[i].n, o: parts[i].o, s: pick.size });
      if (parts.length === 1) {
        if (pick.edge === 'max' && t.max) notes.push(t.max);
        if (pick.edge === 'min' && t.min) notes.push(t.min);
        if (pick.between && t.between) notes.push(t.between.split('{a}').join(pick.between[0]).split('{b}').join(pick.between[1]));
        var r = recRadio(root, parts[i].o, pick.size);
        if (r && r.getAttribute('data-option-available') === 'false' && t.soldout) notes.push(pick.size + ' ' + t.soldout + '.');
      }
    }
    if (!res.length) {
      out.innerHTML = '';
      return;
    }
    root.__exRec = res;
    var sizeHtml = '';
    if (res.length === 1) {
      sizeHtml = '<span class="ex-rec__size">' + recEsc(res[0].s) + '</span>';
    } else {
      for (var k = 0; k < res.length; k++) {
        sizeHtml += '<span class="ex-rec__part"><span class="ex-rec__pn">' + recEsc(res[k].n) + '</span> <span class="ex-rec__size ex-rec__size--sm">' + recEsc(res[k].s) + '</span></span>';
      }
    }
    var label = res.length === 1 ? (t.apply || '{s}').split('{s}').join(res[0].s) : t.applyAll || 'OK';
    notes.push(t.note || '');
    out.innerHTML =
      '<div class="ex-rec__res"><div class="ex-rec__lead"><span class="ex-rec__lab">' + recEsc(t.rec || '') + '</span><span class="ex-rec__sizes">' + sizeHtml + '</span></div>' +
      '<button type="button" class="ex-rec__apply" data-ex-rec-apply>' + recEsc(label) + '</button></div>' +
      '<p class="ex-rec__note">' + recEsc(notes.join(' ')) + '</p>';
  }

  function recApply(root) {
    var res = root.__exRec;
    if (!res || !res.length) return;
    var last = null;
    for (var i = 0; i < res.length; i++) {
      var r = recRadio(root, res[i].o, res[i].s);
      if (r && !r.checked) {
        r.checked = true;
        last = r;
      }
    }
    var details = root.closest('.product-details');
    if (details) details.__exUserTouched = true;
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    var dialog = root.closest('dialog');
    if (dialog && dialog.open) {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
  }

  function recPrefill(root) {
    var hIn = root.querySelector('[data-ex-rec-h]');
    var wIn = root.querySelector('[data-ex-rec-w]');
    if (!hIn || !wIn) return;
    if (!hIn.value && !wIn.value) {
      try {
        var saved = JSON.parse(sessionStorage.getItem('ex_rec') || 'null');
        if (saved) {
          hIn.value = saved.h || '';
          wIn.value = saved.w || '';
        }
      } catch (e) {}
    }
    recUpdate(root);
  }

  document.addEventListener('input', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('[data-ex-rec]') : null;
    if (root) recUpdate(root);
  });

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-ex-rec-apply]');
    if (btn) {
      recApply(btn.closest('[data-ex-rec]'));
      return;
    }
    var opener = t.closest('[data-ex-fit-open]');
    if (opener) {
      var fit = opener.closest('[data-ex-fit]');
      var root = fit ? fit.querySelector('[data-ex-rec]') : null;
      if (root) recPrefill(root);
    }
  });

  // Enter im Größenfeld springt zum Gewicht, im Gewicht schließt es die Tastatur
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target || !event.target.matches) return;
    if (event.target.matches('[data-ex-rec-h]')) {
      event.preventDefault();
      var w = event.target.closest('[data-ex-rec]').querySelector('[data-ex-rec-w]');
      if (w) w.focus();
    } else if (event.target.matches('[data-ex-rec-w]')) {
      event.preventDefault();
      event.target.blur();
    }
  });

  // ------------------------------------------------------------------
  // 20 · Runde 53–55: „DEINE GRÖSSE: L“ in der Größen-Überschrift (Texte in blocks/ex-fit-guide.liquid)
  // Nach einmaliger Eingabe im Size Guide (sessionStorage 'ex_rec', Abschnitt 19) zeigt jede Produktseite die
  // Empfehlung für genau dieses Teil – gleiche Rechnung wie Abschnitt 19 (Fit-Skala, Shorts +1, Damen-Band).
  // Runde 55 (Kevins Wahl aus 6 Optiken: Nr. 3): rechts in der Überschrift „SIZE ···· DEINE GRÖSSE: L“,
  // bei Sets je Teil („T-SHIRT (SIZE) ···· DEINE GRÖSSE: L“), dazu ein kleiner eckiger Punkt im empfohlenen Feld.
  // Bei Einzelteilen ist die Überschrift sonst ausgeblendet – sie erscheint nur mit Empfehlung.
  // Alles per <style> mit Wert-Selektor: Das Theme morpht <variant-picker> bei jedem Wechsel und würde
  // eingefügte Knoten entfernen; ein <style> im <head> bleibt und flackert nicht. Schreibt nur bei Änderung.
  // ------------------------------------------------------------------
  var YZ_N = 0;

  function yzSaved() {
    try {
      var s = JSON.parse(sessionStorage.getItem('ex_rec') || 'null');
      if (!s) return null;
      var h = recNum(s.h);
      var w = recNum(s.w);
      if (h > 0 && h < 3) h = h * 100;
      if (!(h >= 140 && h <= 215 && w >= 35 && w <= 180)) return null;
      return { h: h, w: w };
    } catch (e) {
      return null;
    }
  }

  function yzCss(v) {
    return String(v).replace(/["\\\n]/g, function (c) {
      return c === '\n' ? ' ' : '\\' + c;
    });
  }

  function yzOne(root, saved) {
    var details = root.closest('.product-details');
    if (!details) return;
    var key = details.getAttribute('data-ex-yz');
    if (!key) {
      YZ_N += 1;
      key = 'y' + YZ_N;
      details.setAttribute('data-ex-yz', key);
    }
    var styleEl = document.getElementById('ex-yz-' + key);
    var data, t;
    try {
      data = JSON.parse(root.getAttribute('data-ex-rec') || '{}');
      t = JSON.parse(root.getAttribute('data-ex-rec-t') || '{}');
    } catch (e) {
      return;
    }
    var css = '';
    if (saved) {
      var parts = data.p || [];
      var lab = t.yz || 'Your size';
      for (var i = 0; i < parts.length; i++) {
        var sizes = recSizes(parts[i].v || []);
        if (!sizes) continue;
        if (!recFieldset(root, parts[i].o)) continue;
        var size = recPick(sizes, recScore(saved.h, saved.w, data.g, parts[i].f || 3)).size;
        var radio = recRadio(root, parts[i].o, size);
        var sold = !!(radio && radio.getAttribute('data-option-available') === 'false');
        var fs = '[data-ex-yz="' + key + '"] variant-picker fieldset[data-ex-name="' + yzCss(parts[i].o) + '"]';
        var box = fs + ' .ex-vo__input[value="' + yzCss(size) + '"] + .ex-vo__box';
        var lg = fs + ' > legend';
        var txt = lab + ': ' + size + (sold && t.yzSold ? ' · ' + t.yzSold : '');
        css += box + '{position:relative}' +
          box + '::before{content:"";position:absolute;top:6px;right:6px;width:5px;height:5px;background:currentColor}' +
          lg + '{position:static!important;display:block!important;width:100%!important;height:auto!important;margin:0 0 10px!important;overflow:visible!important;clip:auto!important;clip-path:none!important;white-space:normal!important}' +
          lg + '::after{content:"' + yzCss(txt) + '";float:right;margin-left:12px;color:#0a0a0a;font-weight:600;letter-spacing:.1em}';
      }
    }
    if (!css) {
      if (styleEl) styleEl.remove();
      return;
    }
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'ex-yz-' + key;
      document.head.appendChild(styleEl);
    }
    if (styleEl.textContent !== css) styleEl.textContent = css;
  }

  function yzRender() {
    var roots = document.querySelectorAll('[data-ex-rec]');
    var saved = roots.length ? yzSaved() : null;
    for (var r = 0; r < roots.length; r++) yzOne(roots[r], saved);
    // <style> ohne zugehörigen Bereich (z. B. nach Farbwechsel ohne Neuladen) entfernen
    var st = document.querySelectorAll('style[id^="ex-yz-"]');
    for (var q = 0; q < st.length; q++) {
      if (!document.querySelector('[data-ex-yz="' + st[q].id.slice(6) + '"]')) st[q].remove();
    }
  }

  // Größe von Hand gewechselt → „ausverkauft“-Zusatz bei Sets sofort nachziehen (nicht erst nach dem Morph)
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-picker')) yzRender();
  });

  function start() {
    dropDuplicateWishIcon();
    initAccent();
    initSearch();
    initColourLabel();
    initColourSwitch();
    autoNotifyFromUrl();
    backToTop();
    scan();
    var pending = 0;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = 0;
        scan();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
